export default {
  'header.homepage': 'Главная Страница',
  'header.workspace': 'Рабочее Пространство',
  'login.title': 'Seedance',
  'login.welcome': 'Добро пожаловать в Seedance',
  'login.description': 'Seedance — ваша платформа для генерации видео с помощью ИИ. Безопасные и удобные услуги. Доступ ко всем вашим файлам в любое время и в любом месте.',
  'login.email.placeholder': 'Email или имя пользователя',
  'login.password.placeholder': 'Пароль',
  'login.button': 'Войти',
  'login.loading': 'Вход...',
  'login.divider': 'или',
  'login.signup': 'Нет аккаунта?',
  'login.signup.link': 'Зарегистрироваться',
  'login.error.default': 'Ошибка входа, попробуйте позже',
  'login.success': 'Вход выполнен',
  'login.forgotPassword': 'Забыли пароль?',
  'login.forgotPassword.link': 'Сбросить здесь',
  'login.rememberPassword': 'Запомнить пароль',
  'login.social.comingSoon': 'Этот способ входа скоро появится',
  'captcha.placeholder': 'Код капчи',
  'captcha.refresh': 'Обновить капчу',
  'auth.modal.title': 'Требуется вход',
  'auth.modal.content': 'Сеанс истёк или вы не вошли в систему. Войдите, чтобы продолжить.',
  'auth.modal.ok': 'Перейти к входу',
  'auth.modal.cancel': 'Позже',
  'signup.page.title': 'Регистрация - Seedance',
  'signup.title': 'Seedance',
  'signup.welcome': 'Добро пожаловать в Seedance',
  'signup.description': 'Создайте аккаунт и начните свое путешествие в мир AI-творчества',
  'signup.feature.ai': 'На базе ИИ',
  'signup.feature.video': 'Создание видео',
  'signup.feature.fast': 'Быстрая генерация',
  'signup.feature.creative': 'Безграничное творчество',
  'signup.username.placeholder': 'Введите имя пользователя',
  'signup.email.placeholder': 'Введите email',
  'signup.password.placeholder': 'Введите пароль',
  'signup.confirmPassword.placeholder': 'Подтвердите пароль',
  'signup.inviteCode.placeholder': 'Код приглашения (необязательно)',
  'signup.button': 'Зарегистрироваться',
  'signup.loading': 'Регистрация...',
  'signup.login': 'Уже есть аккаунт?',
  'signup.login.link': 'Войти',
  'signup.error.passwordMismatch': 'Пароли не совпадают',
  'signup.error.default': 'Ошибка регистрации, попробуйте позже',
  'signup.success': 'Регистрация завершена',
  'resetPassword.page.title': 'Сброс пароля - Seedance',
  'resetPassword.page.description': 'Сбросить пароль вашего аккаунта Seedance',
  'resetPassword.title': 'Сброс пароля',
  'resetPassword.email.placeholder': 'Введите ваш email',
  'resetPassword.code.placeholder': 'Введите код подтверждения',
  'resetPassword.password.placeholder': 'Введите новый пароль',
  'resetPassword.button': 'Сбросить',
  'resetPassword.button.loading': 'Сброс...',
  'resetPassword.backToLogin': 'Вернуться к входу',
  'resetPassword.sendCode': 'Получить код',
  'resetPassword.sendCode.sending': 'Отправка...',
  'resetPassword.sendCode.retry': 'Повторить через {seconds}с',
  'resetPassword.error.emailRequired': 'Пожалуйста, введите ваш email',
  'resetPassword.error.codeRequired': 'Пожалуйста, введите код подтверждения',
  'resetPassword.error.passwordRequired': 'Пожалуйста, введите новый пароль',
  'resetPassword.error.passwordLength': 'Пароль должен быть от 6 до 20 символов',
  'resetPassword.error.codeLength': 'Код подтверждения должен состоять из 6 цифр',
  'resetPassword.success.codeSent': 'Код подтверждения отправлен на ваш email',
  'resetPassword.success.reset': 'Пароль успешно сброшен',
  'resetPassword.error.sendFailed': 'Ошибка отправки кода подтверждения, попробуйте позже',
  'resetPassword.error.resetFailed': 'Ошибка сброса пароля, попробуйте позже',
  'resetPassword.error.incomplete': 'Пожалуйста, заполните все обязательные поля',
  'resetPassword.subtitle': 'Введите ваш email и новый пароль для восстановления доступа к аккаунту.',
  'resetPassword.email.label': 'Email',
  'resetPassword.code.label': 'Код подтверждения',
  'resetPassword.password.label': 'Новый пароль',
  'resetPassword.success.title': 'Пароль сброшен',
  'resetPassword.success.description': 'Ваш пароль успешно обновлён. Теперь вы можете войти с новым паролем.',
  'resetPassword.goToLogin': 'Войти',
  'resetPassword.promo.title': 'Защитите свой аккаунт, сохраните своё творчество.',
  'resetPassword.promo.description': 'Мы используем протоколы безопасности банковского уровня, чтобы ваши данные и творения принадлежали только вам.',
  'signup.username.rule.length': 'Имя пользователя должно быть от 4 до 10 символов',
  'signup.username.rule.format': 'Разрешены только буквы, цифры, подчеркивания и дефисы',
  'signup.password.rule.length': 'Пароль должен быть от 6 до 20 символов',
  'signup.password.rule.lowercase': 'Должен содержать строчные буквы',
  'signup.password.rule.uppercase': 'Должен содержать заглавные буквы',
  'signup.password.rule.number': 'Должен содержать цифры',
  'signup.password.rule.special': 'Должен содержать специальные символы',
  'signup.verificationCode.placeholder': 'Введите код подтверждения',
  'signup.verificationCode.send': 'Получить код',
  'signup.verificationCode.sending': 'Отправка...',
  'signup.verificationCode.retry': 'Повторить через {seconds}с',
  'signup.verificationCode.success': 'Код подтверждения отправлен',
  'signup.verificationCode.error': 'Ошибка отправки кода',
  'signup.verificationCode.required': 'Пожалуйста, введите код подтверждения',
  'signup.verificationCode.invalid': 'Неверный формат кода подтверждения',
  'signup.error.emailRequired': 'Пожалуйста, введите ваш email',
  'signup.announcement': 'Функция регистрации сегодня на техническом обслуживании!',
  'sidebar.create': 'Создать',
  'sidebar.allFiles': 'Все файлы',
  'sidebar.starred': 'Избранное',
  'sidebar.folders': 'Папки',
  'sidebar.trash': 'Корзина',
  'sidebar.decrypt': 'Инструмент расшифровки',
  'sidebar.promptMarket': 'Prompt Market',
  'sidebar.channels': 'Каналы',
  'sidebar.dailyChallenge': 'Ежедневный челлендж',
  'sidebar.mediaTools': 'Медиаинструменты',
  'sidebar.storageNodes': 'Узлы хранения',
  'create.tab.textToImage': 'Текст в Изображение',
  'create.tab.textToVideo': 'Текст в Видео',
  'create.tab.imageToImage': 'Изображение в Изображение',
  'create.tab.imageToVideo': 'Изображение в Видео',
  'create.tab.seedanceVideo': 'Seedance Изображение в Видео',
  'create.seedance.title': 'Seedance Изображение в Видео',
  'create.seedance.subtitle': 'ByteDance Doubao Seedance 1.5, создание коротких видео по изображению',
  'create.seedance.noModel': 'Нет доступных моделей Seedance. Настройте в панели администратора.',
  'create.seedance.cameraFixed': 'Камера зафиксирована',
  'create.seedance.cameraFixed.true': 'Да (фиксированная)',
  'create.seedance.cameraFixed.false': 'Нет (динамическая)',
  'create.seedance.watermark': 'Добавить водяной знак',
  'create.seedance.watermark.true': 'Да',
  'create.seedance.watermark.false': 'Нет',
  'create.textToImage.title': 'Текст в Изображение',
  'create.textToImage.subtitle': 'Введите описание и позвольте ИИ нарисовать изображение в вашем воображении',
  'create.textToImage.description': 'Генерировать изображения из текстовых описаний. Эта функция находится в разработке...',
  'create.textToVideo.title': 'Текст в Видео',
  'create.textToVideo.subtitle': 'Введите описания сцен и управление камерой для создания высококачественных видео',
  'create.textToVideo.description': 'Генерировать видео из текстовых описаний. Эта функция находится в разработке...',
  'create.imageToImage.title': 'Изображение в Изображение',
  'create.imageToImage.description': 'Генерировать новые изображения из эталонных изображений. Эта функция находится в разработке...',
  'create.imageToVideo.title': 'Изображение в Видео',
  'create.imageToVideo.description': 'Генерировать видео из эталонных изображений. Эта функция находится в разработке...',
  'sidebar.feedback': 'Отзывы',
  'sidebar.about': 'О программе',
  'sidebar.productLog': 'Обновления',
  'promptMarket.title': 'Prompt Market',
  'promptMarket.subtitle': 'Изучайте рецепты вдохновения ИИ от лучших авторов и раскрывайте творческий потенциал',
  'promptMarket.searchPlaceholder': 'Поиск промптов, стилей, моделей...',
  'promptMarket.search': 'Поиск',
  'promptMarket.all': 'Все',
  'promptMarket.tabAll': 'Все рекомендации',
  'promptMarket.tabImage': 'Текст в изображение',
  'promptMarket.tabVideo': 'Текст в видео',
  'promptMarket.tabAudio': 'Текст в музыку',
  'promptMarket.sortLatest': 'Новые',
  'promptMarket.sortHot': 'Популярные',
  'promptMarket.sortSales': 'По продажам',
  'promptMarket.publish': 'Опубликовать',
  'promptMarket.empty': 'Пока нет объявлений. Опубликуйте первым!',
  'promptMarket.free': 'Бесплатно',
  'promptMarket.token': 'TOKEN',
  'promptMarket.loadFailed': 'Ошибка загрузки',
  'promptMarket.listSuccess': 'Успешно опубликовано',
  'promptMarket.listFailed': 'Ошибка публикации',
  'market.label': 'МАРКЕТ ПРОМПТОВ',
  'market.h1': 'Раскройте свою',
  'market.h1.highlight': 'творческую силу.',
  'market.sub': 'Премиум-платформа для AI-промптов: изображения, видео и музыка. Проверенные рецепты для OpenAI, Google, Midjourney, Runway, Kling, Luma, Suno, ElevenLabs и других. Хватит гадать — начните создавать.',
  'market.providers.title': 'Совместимо с ведущими моделями и платформами',
  'market.card1.title': 'Мгновенная интеграция',
  'market.card1.desc': 'Пропустите кривую обучения промпт-инжинирингу. Импортируйте проверенные промпты в рабочий процесс одним кликом.',
  'market.card2.title': 'Монетизируйте творчество',
  'market.card2.desc': 'Превратите лучшие промпты в пассивный доход. Присоединяйтесь к тысячам авторов, зарабатывающих на экспертизе в AI.',
  'market.card3.title': 'Проверенное качество',
  'market.card3.desc': 'Каждое объявление проверяется и тестируется вручную. Гарантируем стабильный результат в разных моделях.',
  'market.card4.title': 'Исследуйте лабораторию',
  'market.card4.desc': 'Откройте для себя более 10 000 ассетов, созданных сообществом.',
  'market.cta': 'Открыть Маркет Промптов',
  'home.mediaTools.title': 'Медиаинструменты',
  'home.mediaTools.subtitle': 'Онлайн, без установки. Легко обрабатывайте изображения, видео и аудио.',
  'home.mediaTools.toolSuffix': '',
  'home.mediaTools.imageCompress.title': 'Сжатие изображений',
  'home.mediaTools.imageCompress.description': 'Умное сжатие с сохранением качества. Пакетная обработка.',
  'home.mediaTools.videoCompress.title': 'Сжатие видео',
  'home.mediaTools.videoCompress.description': 'Эффективное сжатие с настройкой разрешения и битрейта. Много форматов.',
  'home.mediaTools.audioCompress.title': 'Сжатие аудио',
  'home.mediaTools.audioCompress.description': 'Оптимизация размера с сохранением ясности. MP3, AAC и др.',
  'filelist.column.name': 'Имя',
  'filelist.column.size': 'Размер',
  'filelist.column.updateTime': 'Изменен',
  'filelist.column.recycletime': 'Дата удаления',
  'filelist.column.actions': 'Действия',
  'filelist.total': 'Всего {total} элементов',
  'filelist.action.upload': 'Загрузить',
  'filelist.action.newFolder': 'Новая папка',
  'filelist.action.refresh': 'Обновить',
  'filelist.action.search': 'Поиск файлов',
  'filelist.action.batchDownload': 'Скачать',
  'filelist.action.batchDelete': 'Удалить',
  'filelist.action.download': 'Скачать',
  'filelist.action.preview': 'Просмотр',
  'filelist.action.rename': 'Переименовать',
  'filelist.selected': 'Выбрано: {count}',
  'page.cloudDrive.title': 'Мой Cloud Drive',
  'page.cloudDrive.description': 'AIMATEX Cloud Drive - Безопасно храните и управляйте вашими файлами',
  'modal.fileUpload.title': 'Загрузка файлов',
  'modal.fileUpload.dragText': 'Перетащите файлы сюда или нажмите для загрузки',
  'modal.fileUpload.start': 'Начать загрузку',
  'modal.fileUpload.cancel': 'Отмена',
  'modal.fileUpload.clear': 'Очистить список',
  'modal.fileUpload.encrypt': 'Зашифровать выбранные',
  'modal.fileUpload.addMore': 'Добавить',
  'modal.fileUpload.remove': 'Удалить',
  'modal.fileUpload.error.noSelection': 'Выберите файлы для удаления',
  'modal.fileUpload.error.noEncryption': 'Выберите файлы для шифрования',
  'modal.fileUpload.error.noClear': 'Нет файлов для очистки',
  'modal.fileUpload.error.noStart': 'Нет файлов для загрузки',
  'modal.fileUpload.error.noCancel': 'Нет активных загрузок для отмены',
  'modal.fileUpload.error.fileSize': 'Превышен размер файла',
  'modal.fileUpload.error.fileType': 'Неподдерживаемый тип файла',
  'modal.fileUpload.error.maxCount': 'Превышено максимальное количество файлов',
  'modal.fileUpload.duplicate.title': 'Файл уже существует',
  'modal.fileUpload.duplicate.skip': 'Пропустить',
  'modal.fileUpload.duplicate.replace': 'Заменить',
  'modal.fileUpload.duplicate.rename': 'Переименовать',
  'modal.fileUpload.status.pending': 'Ожидание',
  'modal.fileUpload.status.uploading': 'Загрузка',
  'modal.fileUpload.status.success': 'Завершено',
  'modal.fileUpload.status.error': 'Ошибка',
  'modal.fileUpload.status.cancelled': 'Отменено',
  'modal.fileUpload.status.duplicated': 'Дубликат',
  'modal.fileUpload.table.filename': 'Имя файла',
  'modal.fileUpload.table.size': 'Размер',
  'modal.fileUpload.table.status': 'Статус',
  'modal.fileUpload.table.progress': 'Прогресс',
  'modal.fileUpload.table.actions': 'Действия',
  'modal.fileUpload.speed': 'Скорость загрузки',
  'modal.fileUpload.remainingTime': 'Осталось времени',
  'modal.fileUpload.total.progress': 'Общий прогресс',
  'modal.fileUpload.error.message': 'Ошибка загрузки: {message}',
  'modal.fileUpload.confirm.clear': 'Очистить список загрузки?',
  'modal.fileUpload.confirm.cancel': 'Отменить загрузку?',
  'modal.fileUpload.clear.mobile': 'Очистить',
  'modal.fileUpload.encrypt.mobile': 'Шифровать',
  'modal.fileUpload.addMore.mobile': 'Добавить',
  'productLog.title': 'Обновления продукта',
  'security.features.title': 'Функции безопасности',
  'security.features.localDecryption.title': 'Локальная расшифровка',
  'security.features.localDecryption.description': 'Все операции расшифровки выполняются локально в вашем браузере, содержимое файла и пароль никогда не покидают ваше устройство',
  'security.features.militaryEncryption.title': 'Военное шифрование',
  'security.features.militaryEncryption.description': 'Использует алгоритм шифрования AES-256-CBC, самый безопасный стандарт симметричного шифрования, способный противостоять всем известным атакам',
  'security.features.privacyProtection.title': 'Защита конфиденциальности',
  'security.features.privacyProtection.description': 'Строгий механизм защиты конфиденциальности, пароли расшифровки не сохраняются, содержимое файлов не записывается',
  'security.features.smartDecryption.title': 'Умная блочная расшифровка',
  'security.features.smartDecryption.description': 'Технология умной блочной расшифровки значительно повышает скорость расшифровки при снижении использования памяти',
  'security.features.learnMore': 'Узнать больше',
  'security.features.modal.title': 'Подробности о функциях безопасности',
  'security.features.modal.close': 'Закрыть',
  'decrypt.security.modal.title': 'Уведомление безопасности',
  'decrypt.security.modal.description': 'Все операции расшифровки выполняются локально, ваш пароль и содержимое файла никогда не отправляются на сервер',
  'decrypt.security.modal.vip.title': 'Как VIP-пользователь, вы можете:',
  'decrypt.security.modal.vip.feature1': 'Расшифровывать файлы любого размера',
  'decrypt.security.modal.vip.feature2': 'Использовать умную блочную расшифровку для лучшей эффективности',
  'decrypt.security.modal.vip.feature3': 'Поддерживать пакетную расшифровку больших файлов',
  'decrypt.security.modal.free.title': 'Важно: Процесс расшифровки требует примерно в 3 раза больше памяти браузера, чем размер файла.',
  'decrypt.security.modal.free.feature1': 'Бесплатные пользователи ограничены 4GB на файл',
  'decrypt.security.modal.free.feature2': 'Обновитесь до VIP для расшифровки файлов любого размера',
  'decrypt.security.modal.free.feature3': 'Если браузер зависает, рассмотрите обновление до VIP для использования блочной расшифровки',
  'security.diagram.plaintext.block1': 'Блок открытого текста 1',
  'security.diagram.plaintext.block2': 'Блок открытого текста 2',
  'security.diagram.ciphertext.block1': 'Блок зашифрованного текста 1',
  'security.diagram.ciphertext.block2': 'Блок зашифрованного текста 2',
  'security.diagram.key': 'Ключ',
  'security.diagram.aes.encryption': 'Шифрование AES',
  'security.diagram.xor.operation': 'Операция XOR',
  'security.diagram.iv': 'Вектор инициализации',
  'decrypt.fileList.empty': 'Нет файлов, добавьте файлы для расшифровки',
  'decrypt.fileList.column.name': 'Имя файла',
  'decrypt.fileList.column.size': 'Размер',
  'decrypt.fileList.column.status': 'Статус',
  'decrypt.fileList.column.actions': 'Действия',
  'decrypt.fileList.status.pending': 'Ожидание',
  'decrypt.fileList.status.decrypting': 'Расшифровка',
  'decrypt.fileList.status.success': 'Завершено',
  'decrypt.fileList.status.error': 'Ошибка',
  'decrypt.fileList.action.info': 'Инфо',
  'decrypt.password.modal.title': 'Введите пароль расшифровки',
  'decrypt.password.modal.placeholder': 'Введите пароль',
  'decrypt.password.modal.hint': 'Введите пароль, установленный при шифровании, он будет использован только для локальной расшифровки',
  'decrypt.message.invalidFile': 'Выберите только файлы .encrypted',
  'decrypt.message.duplicate': 'Файл "{filename}" уже существует, дубликат автоматически удален',
  'decrypt.message.oversizeTitle': 'Превышен размер файла',
  'decrypt.message.oversizeContent': 'Следующие файлы превышают бесплатный лимит (4GB):',
  'decrypt.message.oversizeHint': 'Обновитесь до VIP для расшифровки файлов любого размера',
  'decrypt.message.selectFile': 'Выберите файлы для расшифровки',
  'decrypt.message.enterPassword': 'Введите пароль расшифровки',
  'decrypt.message.decryptSuccess': 'Файл {filename} сохранен',
  'decrypt.message.saveCancel': 'Сохранение файла {filename} отменено',
  'decrypt.message.downloadSuccess': 'Файл {filename} сохранен в папку загрузок',
  'decrypt.message.decryptError': 'Ошибка расшифровки файла {filename}: {error}',
  'decrypt.message.batchError': 'Ошибка пакетной расшифровки, попробуйте снова',
  'common.unknown': 'Неизвестно',
  'common.philosophy': 'Технология должна служить народу',
  'common.speed': 'Скорость',
  'common.timeSpent': 'Затраченное время',
  'common.remaining': 'Осталось',
  'sideMenu.storageInfo.title': 'Объем хранилища',
  'sideMenu.storageInfo.usage': 'Использовано {used} / Всего {total}',
  'sideMenu.storageStats.title': 'Статистика хранилища',
  'sideMenu.storageStats.overview': 'Обзор',
  'sideMenu.storageStats.totalFiles': 'Всего файлов',
  'sideMenu.storageStats.totalSize': 'Общий размер',
  'sideMenu.storageStats.fileTypes': 'Распределение типов файлов',
  'sideMenu.storageStats.providers': 'Поставщики услуг',
  'common.default': 'По умолчанию',
  'common.regionCode': 'Код региона',
  'common.nodeType': 'Тип узла',
  'common.storageUsed': 'Использовано',
  'common.storageAvailable': 'Доступно',
  'common.storageLimit': 'Общая емкость',
  'common.storageUsageDetail': 'Использовано {used} / Всего {total}',
  'common.defaultNode': 'Узел по умолчанию',
  'common.confirm': 'Подтвердить',
  'common.cancel': 'Отмена',
  'common.latency': 'Задержка',
  'common.retry': 'Повторить',
  'cloudDrive.nodeSelect.title': 'Выбрать узел хранения',
  'cloudDrive.nodeSelect.addNode': 'Добавить узел хранения',
  'cloudDrive.nodeSelect.deleteConfirm.title': 'Подтвердите удаление узла',
  'cloudDrive.nodeSelect.deleteConfirm.content': 'Вы уверены, что хотите удалить узел "{nodeName}"? Это действие нельзя отменить!',
  'cloudDrive.nodeSelect.deleteSuccess': 'Узел успешно удален',
  'cloudDrive.nodeSelect.deleteFailed': 'Не удалось удалить узел',
  
  // Создание узла
  'cloudDrive.nodeCreate.title': 'Добавить узел хранения',
  'cloudDrive.nodeCreate.selectProvider': 'Выберите облачного провайдера',
  'cloudDrive.nodeCreate.nodeName': 'Имя узла',
  'cloudDrive.nodeCreate.nodeNamePlaceholder': 'Оставьте пустым для использования имени по умолчанию',
  'cloudDrive.nodeCreate.nameMaxLength': 'Имя узла не может превышать 50 символов',
  'cloudDrive.nodeCreate.noProviders': 'Нет доступных облачных провайдеров',
  'cloudDrive.nodeCreate.pingLatency': 'Задержка {value} мс',
  'cloudDrive.nodeCreate.pingTesting': 'Тестирование задержки...',
  'cloudDrive.nodeCreate.pingFailed': 'Ошибка теста задержки',
  'cloudDrive.nodeCreate.pingUnavailable': 'Тест задержки недоступен',
  'cloudDrive.nodeCreate.sortByLatency': 'Сортировать по задержке',
  'cloudDrive.nodeCreate.selectRegion': 'Выбрать регион',
  'cloudDrive.nodeCreate.selectedRegion': 'Выбранный регион',
  'cloudDrive.nodeCreate.noRegions': 'Нет доступных регионов',
  'cloudDrive.nodeCreate.selectProviderPlaceholder': 'Пожалуйста, выберите облачного провайдера',
  'cloudDrive.nodeCreate.selectProviderRequired': 'Пожалуйста, сначала выберите облачного провайдера',
  'cloudDrive.nodeCreate.selectRegionRequired': 'Пожалуйста, сначала выберите регион',
  'cloudDrive.nodeCreate.loadProvidersFailed': 'Ошибка загрузки списка облачных провайдеров',
  'cloudDrive.nodeCreate.loadRegionsFailed': 'Ошибка загрузки списка регионов',
  'cloudDrive.nodeCreate.nodeType': 'Тип узла',
  'cloudDrive.nodeCreate.nodeType.standard': 'Стандартное хранилище',
  'cloudDrive.nodeCreate.nodeType.lowFreq': 'Хранилище низкой частоты',
  'cloudDrive.nodeCreate.nodeType.archive': 'Архивное хранилище',
  'cloudDrive.nodeCreate.storageLimit': 'Лимит хранилища',
  'cloudDrive.nodeCreate.storageLimitRequired': 'Пожалуйста, введите лимит хранилища',
  'cloudDrive.nodeCreate.storageLimitMin': 'Лимит хранилища не может быть меньше 1 ГБ',
  'cloudDrive.nodeCreate.storageLimitPlaceholder': 'Введите лимит хранилища (ГБ)',
  'cloudDrive.nodeCreate.success': 'Узел хранения успешно создан',
  'cloudDrive.nodeCreate.failed': 'Не удалось создать узел хранения',
  
  // Редактирование узла
  'cloudDrive.nodeEdit.title': 'Редактировать узел',
  'cloudDrive.nodeEdit.name': 'Имя узла',
  'cloudDrive.nodeEdit.nameRequired': 'Пожалуйста, введите имя узла',
  'cloudDrive.nodeEdit.nameMaxLength': 'Имя узла не может превышать 50 символов',
  
  // TextToImage page internationalization
  'create.prompt': 'Запрос',
  'create.prompt.placeholder': 'напр.: киберпанк-кот, идущий в космосе, неоновый фон, высокая детализация...',
  'create.prompt.required': 'Пожалуйста, введите запрос',
  'create.prompt.generate': 'ИИ Сгенерировать Запрос',
  'create.prompt.enrich': 'ИИ Обогатить Запрос',
  'create.prompt.generate.success': 'Запрос успешно сгенерирован!',
  'create.prompt.generate.error': 'Не удалось сгенерировать запрос, пожалуйста, попробуйте снова',
  'create.prompt.generate.empty': 'Запрос не был сгенерирован, пожалуйста, попробуйте снова',
  'create.prompt.restore': 'Восстановить',
  'create.prompt.restore.success': 'Восстановлено к исходному запросу',
  'create.prompt.restore.tooltip': 'Восстановить к запросу до генерации/обогащения ИИ',
  'create.negativePrompt': 'Негативный Запрос',
  'create.ratio': 'Соотношение Сторон',
  'create.style': 'Художественный Стиль',
  'create.batchSize': 'Размер Партии',
  'create.generate': 'Сгенерировать Сейчас',
  'create.negativePrompt.tooltip': 'Элементы, которые вы не хотите видеть на изображении',
  'create.negativePrompt.placeholder': 'напр.: размытие, низкое качество, деформированные пальцы...',
  'create.generating': 'Генерация...',
  'create.generating.waiting': 'ИИ создает, пожалуйста, подождите...',
  'create.result.title': 'Сгенерированные результаты',
  'create.downloadAll': 'Скачать все',
  'create.aspectRatio.1:1': '1:1 (Квадрат)',
  'create.aspectRatio.16:9': '16:9 (Горизонтальный)',
  'create.aspectRatio.9:16': '9:16 (Вертикальный)',
  'create.aspectRatio.21:9': '21:9 (Кино)',
  'create.aspectRatio.4:3': '4:3 (Классический)',
  'create.style.general': 'Общий',
  'create.style.anime': 'Аниме',
  'create.style.realistic': 'Реалистичный',
  'create.style.3d-render': '3D Render',
  'create.style.cyberpunk': 'Киберпанк',
  'create.settings.loadFailed': 'Не удалось загрузить настройки типа создания, отображаются все варианты',
  'create.settings.error': 'Не удалось загрузить настройки, отображаются все варианты',
  'create.noAvailableTabs': 'Нет доступных типов создания',
  'create.network.error.title': 'Ошибка Сетевого Подключения',
  'create.network.error.description': 'Не удалось загрузить настройки типа создания. Пожалуйста, проверьте подключение к сети и обновите страницу',
  'create.network.error.refresh': 'Обновить Страницу',
  
  // TextToVideo page internationalization
  'create.prompt.video': 'Описание Сцены Видео (Prompt)',
  'create.prompt.video.placeholder': 'напр., Собака-астронавт танцует на поверхности луны, 8K, кинематографическое освещение, сюрреализм.',
  'create.prompt.video.required': 'Пожалуйста, введите описание сцены видео',
  'create.generate.video': 'Сгенерировать Видео Сейчас',
  'create.video.ratio': 'Соотношение Сторон Видео',
  'create.video.camera': 'Движение Камеры',
  'create.video.duration': 'Длительность Видео (секунды)',
  'create.video.format': 'Формат Вывода',
  'create.cameraMotion.none': 'Без Движения (None)',
  'create.cameraMotion.zoomIn': 'Приближение (Zoom In)',
  'create.cameraMotion.dollyOut': 'Отдаление (Dolly Out)',
  'create.cameraMotion.panLeft': 'Панорама Влево (Pan Left)',
  'create.cameraMotion.tiltUp': 'Наклон Вверх (Tilt Up)',
  'create.cameraMotion.orbital': '360° Орбитальное',
  'create.negativePrompt.video.placeholder': 'напр., водяные знаки, мерцание, низкое разрешение, размытые персонажи...',
  'create.sora.thinking': 'Sora размышляет...',
  'create.video.analyzing': 'Анализ изображения и запроса, ИИ создает...',
  'create.video.info': 'Длительность: {duration}с | Соотношение: {ratio}',
  'create.video.preview': 'Предпросмотр Видео',
  'create.video.result': 'Финальный Предпросмотр Видео',
  'create.video.empty': 'Сгенерированные результаты будут отображены здесь',
  'create.download': 'Скачать Видео',
  'create.duration.format': '{duration}с',
  'create.duration.4s': '4с',
  'create.duration.8s': '8с',
  'create.duration.15s': '15с',
  'create.estimated.price': 'Оценка: {price}',
  'create.model.select': 'Выбрать Модель',
  'create.model.loading': 'Загрузка моделей...',
  'create.model.loadFailed': 'Не удалось загрузить список моделей',
  'create.model.family.select': 'Выбрать Семейство Моделей',
  'create.model.family.select.placeholder': 'Пожалуйста, выберите семейство моделей',
  'create.model.family.loadFailed': 'Не удалось загрузить список семейств моделей',
  'create.style.select.placeholder': 'Пожалуйста, выберите художественный стиль (необязательно, по умолчанию используется модель семейства)',
  'create.model.style.loadFailed': 'Не удалось загрузить список моделей стилей',
  'create.model.description': 'Описание Модели',
  'create.model.aspectResolution': 'Разрешение Соотношения',
  'create.model.fps': 'Частота Кадров',
  'create.model.features': 'Поддерживаемые Функции',
  'create.model.feature.cameraMotion': 'Движение Камеры',
  'create.model.feature.img2video': 'Изображение в Видео',
  'create.model.feature.videoEdit': 'Редактирование Видео',
  'create.model.price.perSecond': '/сек',
  'create.model.detail': 'Детали',
  'create.history.title': 'История генерации',
  'create.history.refresh': 'Обновить',
  'create.history.empty': 'Нет истории генерации',
  'create.history.total': 'Всего {total} записей',
  'create.history.status.processing': 'Обработка',
  'create.history.status.success': 'Успешно',
  'create.history.status.failed': 'Ошибка',
  'create.history.failed.noImage': 'Генерация не удалась',
  'create.history.downloadAll.start': 'Начало загрузки {count} изображений',
  'create.history.downloadAll.tooltip': 'Загрузить все {count} изображений',
  'create.history.download.tooltip': 'Загрузить изображение',
  'create.history.detail.tooltip': 'Подробнее',
  'create.history.noPrompt': 'Нет промпта',
  'create.history.deleteConfirm.title': 'Подтвердить удаление',
  'create.history.deleteConfirm.content': 'Вы уверены, что хотите удалить эту задачу? Это действие нельзя отменить.',
  'create.history.deleteSuccess': 'Успешно удалено',
  'create.history.deleteFailed': 'Ошибка удаления',
  'create.taskDetail.title': 'Детали задачи',
  'create.taskDetail.loading': 'Загрузка...',
  'create.taskDetail.loadFailed': 'Не удалось загрузить детали задачи',
  'create.taskDetail.noData': 'Нет данных',
  'create.taskDetail.basicInfo': 'Основная информация',
  'create.taskDetail.model': 'Модель',
  'create.taskDetail.taskType': 'Тип задачи',
  'create.taskDetail.createTime': 'Время создания',
  'create.taskDetail.duration': 'Длительность генерации',
  'create.taskDetail.prompt': 'Запрос',
  'create.taskDetail.error': 'Сообщение об ошибке',
  'create.taskDetail.outputFiles': 'Выходные файлы',
  'create.taskDetail.downloadAll': 'Скачать все',
  'create.taskDetail.downloadAll.start': 'Начало загрузки {count} изображений',
  'create.taskDetail.modelInfo': 'Информация о модели',
  'create.taskDetail.defaultResolution': 'Разрешение по умолчанию',
  'create.taskDetail.maxResolution': 'Максимальное разрешение',
  'create.taskDetail.aspectRatios': 'Поддерживаемые соотношения',
  'create.taskDetail.formats': 'Поддерживаемые форматы',
  'create.taskDetail.prompt.copied': 'Запрос скопирован',
  'create.taskDetail.liked': 'Понравилось',
  'create.taskDetail.like': 'Нравится',
  'create.taskDetail.collected': 'Сохранено',
  'create.taskDetail.collect': 'Сохранить',
  'create.taskDetail.linkCopied': 'Ссылка скопирована',
  'create.taskDetail.share': 'Поделиться',
  'create.taskDetail.outputs': 'Выходы',
  'create.taskDetail.preview': 'Предпросмотр',
  'create.taskDetail.download': 'Скачать',
  'create.taskDetail.generationFailed': 'Генерация не удалась',
  'create.taskDetail.generating': 'Генерация...',
  'create.taskDetail.promptLabel': 'Запрос',
  'create.taskDetail.copy': 'Копировать',
  'create.taskDetail.executionStats': 'Статистика выполнения',
  'create.taskDetail.creditsCost': 'Стоимость кредитов',
  'create.taskDetail.modelSpecs': 'Спецификации модели',
  'create.taskDetail.capabilities': 'Возможности',
  'create.taskDetail.supportedRatios': 'Поддерживаемые соотношения',
  'create.taskDetail.dataError': 'Ошибка данных',
  'create.taskDetail.more': 'Больше',
  'create.taskDetail.downloading': 'Загрузка...',
  'create.taskDetail.points': 'баллы',
  'create.taskDetail.seconds': 'с',
  'create.taskDetail.status.success': 'УСПЕХ',
  'create.taskDetail.status.failed': 'НЕУДАЧА',
  'create.taskDetail.status.processing': 'ОБРАБОТКА',
  'create.taskDetail.status.queued': 'В ОЧЕРЕДИ',
  'create.taskDetail.status.generating': 'ГЕНЕРАЦИЯ',
  'create.taskDetail.durationLabel': 'Длительность',
  'create.taskDetail.taskParams': 'Параметры задачи',
  'create.taskDetail.aspectRatio': 'Соотношение сторон',
  'create.taskDetail.inputType': 'Тип ввода',
  'create.taskDetail.modelCode': 'Код модели',
  'create.taskDetail.regenerate': 'Регенерировать',
  'create.taskDetail.feature.developing': 'Функция в разработке',
  'create.taskDetail.result': 'Результат генерации',
  'create.taskDetail.copyPrompt': 'Копировать запрос',
  'create.taskDetail.imageDimensions': 'Размеры',
  'create.taskDetail.fileSize': 'Размер файла',
  'create.taskDetail.loadingImageInfo': 'Загрузка информации об изображении...',
  'create.history.failed.noVideo': 'Генерация не удалась',
  'create.video.generate.cancelled.polling': 'Опрос задачи отменен',
  'create.video.generate.queued': 'Задача генерации видео отправлена, в очереди...',
  'create.video.generate.noUrl': 'Генерация видео завершена, но URL видео не найден',
  'create.video.status.checkFailed': 'Не удалось проверить статус задачи',
  'create.video.generate.processing': 'Задача генерации видео отправлена, обрабатывается...',
  'create.video.taskQueue': 'Очередь задач',
  'create.video.polling': 'Генерация видео, пожалуйста, подождите...',
  'create.video.ratio.invalid': 'Пожалуйста, выберите соотношение сторон видео, поддерживаемое моделью',
  'create.waitingTask.queue': 'Очередь задач',
  'create.waitingTask.empty': 'Нет задач в процессе',
  'create.waitingTask.generating': 'Генерация...',
  'create.waitingTask.queued': 'В очереди',
  'create.waitingTask.cancel': 'Отменить задачу',
  // HistorySection новая интернационализация
  'create.history.copyPrompt': 'Копировать промпт',
  'create.history.download': 'Скачать',
  'create.history.delete': 'Удалить',
  'create.history.generating': 'Генерация...',
  'create.history.generationFailed': 'Генерация не удалась',
  'create.history.noPreview': 'Нет предпросмотра',
  // ImageToVideo новая интернационализация
  'create.i2v.fileType.error': 'Пожалуйста, выберите файл изображения',
  'create.i2v.fileSize.error': 'Размер файла изображения не может превышать 10 МБ',
  'create.i2v.imageSize.error': 'Высота изображения должна быть не менее {minHeight}px, текущий размер изображения {width}x{height}px',
  'create.i2v.fileRead.error': 'Ошибка чтения изображения',
  'create.i2v.replaceImage': 'Заменить изображение',
  'create.i2v.upload.supportedFormats': 'Поддерживает JPG, PNG, WebP, JFIF',
  'create.i2v.upload.required': 'Пожалуйста, загрузите эталонное изображение',
  'create.i2v.upload': 'Загрузить Эталонное Изображение (Начальный Кадр)',
  'create.i2v.upload.click': 'Нажмите или перетащите для загрузки',
  'create.i2v.prompt.required': 'Пожалуйста, введите описание движения',
  'create.i2v.uploading.image': 'Загрузка изображения в облако...',
  'create.i2v.upload.success': 'Изображение успешно загружено',
  'create.i2v.upload.failed': 'Ошибка загрузки изображения, пожалуйста, попробуйте снова',
  'create.i2v.original': 'Оригинал (начальный кадр)',
  'create.i2v.result': 'Сравнение генерации',
  'create.i2v.empty': 'Сравнение сгенерированных результатов и оригинального изображения будет отображаться здесь',
  'create.generate.i2v': 'Начать генерацию видео',
  'create.prompt.i2v.placeholder': 'Например: Заставить человека на изображении начать идти, листья на фоне качаются на ветру...',
  'create.prompt.enhance.tooltip': 'Обогатить промпт с помощью ИИ, чтобы сделать описание более детальным и живым',
  'create.prompt.enhance': 'Обогатить с ИИ',
  'create.prompt.enhance.empty': 'Пожалуйста, сначала введите базовый промпт',
  'create.prompt.enhance.success': 'Промпт успешно обогащен!',
  'create.prompt.enhance.empty.result': 'Обогащенный промпт не сгенерирован, пожалуйста, попробуйте снова',
  'create.prompt.enhance.error': 'Ошибка обогащения промпта, пожалуйста, попробуйте снова',
  'create.prompt.version.history': 'История Версий',
  'create.prompt.version.history.tooltip': 'Просмотр истории версий промпта',
  // TaskDetailModal новая интернационализация
  'create.taskDetail.unnamedTask': 'Безымянная задача',
  'create.taskDetail.prompt.title': 'Промпт',
  'create.taskDetail.tokenCost': 'Стоимость токенов',
  'create.taskDetail.publish': 'Опубликовать в сообществе',
  'create.taskDetail.selectCover': 'Выбрать обложку',
  'create.taskDetail.selectChannel': 'Выбрать канал',
  'create.taskDetail.selectChallenge': 'Выбрать задание',
  'create.taskDetail.publishSuccess': 'Успешно опубликовано',
  'create.taskDetail.loadChannelsFailed': 'Не удалось загрузить каналы',
  'create.taskDetail.loadChallengesFailed': 'Не удалось загрузить задания',
  'create.taskDetail.publishFailed': 'Не удалось опубликовать',
  'create.taskDetail.daysLeft': 'Осталось {days} дней',
  // ModelDetailModal новая интернационализация
  'create.model.capability.t2v': 'T2V (Текст в Видео)',
  'create.model.capability.img2video': 'Изображение в Видео',
  'create.model.capability.videoEdit': 'Редактирование Видео',
  'create.model.capability.characterConsistency': 'Последовательность Персонажей',
  'create.model.capability.reference': 'Ссылка',
  'create.model.capability.cameraMotion': 'Движение Камеры',
  'create.model.aspectRatios': 'Соотношения Сторон',
  'create.model.resolution': 'Разрешение',
  'create.model.resolution.default': 'По умолчанию',
  'create.model.resolution.max': 'Максимум',
  'create.model.duration': 'Длительность',
  'create.model.formats': 'Форматы',
  'create.model.like': 'Нравится',
  'create.model.liked': 'Понравилось',
  'create.model.unliked': 'Больше не нравится',
  'create.model.favorite': 'Избранное',
  'create.model.favorited': 'Добавлено в избранное',
  'create.model.unfavorited': 'Удалено из избранного',
  'create.model.share': 'Поделиться',
  'create.model.linkCopied': 'Ссылка скопирована',
  'create.model.capabilities': 'Возможности',
  'create.model.free': 'Бесплатно',
  'create.model.tokenCost.display': '{count} token',
  // Другие новые ключи
  'create.aspectRatio.portrait': 'Портрет',
  'create.aspectRatio.landscape': 'Альбом',
  'create.video.ratio.placeholder': 'Пожалуйста, выберите соотношение сторон видео',
  'create.video.format.placeholder': 'Пожалуйста, выберите формат вывода',
  'create.video.style': 'Стиль Видео',
  'create.video.style.tooltip': 'Выбрать стиль генерации видео',
  'create.video.style.placeholder': 'Пожалуйста, выберите стиль видео',
  'create.video.quality': 'Качество Видео',
  'create.video.quality.tooltip': 'Выбрать качество генерации видео',
  'create.video.quality.placeholder': 'Пожалуйста, выберите качество видео',
  'create.duration.select.placeholder': 'Пожалуйста, выберите длительность видео',
  'create.model.select.placeholder': 'Пожалуйста, сначала выберите модель',
  'video.not.supported': 'Ваш браузер не поддерживает воспроизведение видео.',
  // UnderDevelopment Интернационализация
  'underDevelopment.comingSoon': 'Скоро',
  'underDevelopment.title': 'Функция в разработке',
  'underDevelopment.subtitle': 'Мы усердно работаем над разработкой этой функции, следите за обновлениями!',
  'underDevelopment.backHome': 'Вернуться на главную',
  'underDevelopment.goBack': 'Назад',
  // UserMenu Интернационализация
  'userMenu.email.notBound': 'Email не привязан',
  'userMenu.status.verified': 'Подтвержден',
  'userMenu.status.guest': 'Гость',
  'userMenu.recharge': 'Пополнить сейчас',
  'userMenu.community': 'Сообщество',
  'userMenu.group.account': 'Настройки аккаунта',
  'userMenu.group.assets': 'Активы и заказы',
  'userMenu.group.workspace': 'Рабочее пространство',
  'userMenu.group.support': 'Поддержка',
  'userMenu.item.profile': 'Профиль',
  'userMenu.item.settings': 'Настройки',
  'userMenu.item.security': 'Безопасность',
  'userMenu.item.privacy': 'Конфиденциальность',
  'userMenu.item.wallet': 'Мой кошелек',
  'userMenu.item.subscription': 'Подписка',
  'userMenu.item.orders': 'История заказов',
  'userMenu.item.works': 'Мои работы',
  'userMenu.item.notifications': 'Уведомления',
  'userMenu.item.help': 'Центр помощи',
  'userMenu.item.invite': 'Пригласить друзей',
  'userMenu.item.feedback': 'Обратная связь',
  'userMenu.item.about': 'О нас',
  'userMenu.level': 'Уровень',
  'userMenu.member.vip1': 'Базовый участник',
  'userMenu.member.vip2': 'Серебряный участник',
  'userMenu.member.vip3': 'Золотой участник',
  'userMenu.member.vip4': 'Алмазный участник',
  'userMenu.member.vip5': 'Высший участник',
  'userMenu.logout': 'Выйти',
  // Recharge Agreement Интернационализация
  'rechargeAgreement.back': 'Назад',
  'rechargeAgreement.title': 'Соглашение об Услуге Пополнения',
  'rechargeAgreement.lastUpdated': 'Последнее обновление: ',
  'rechargeAgreement.goRecharge': 'Перейти к Пополнению',
  'rechargeAgreement.section1.title': 'I. Область Соглашения',
  'rechargeAgreement.section1.content1': 'Это соглашение является юридическим соглашением между вами и платформой относительно услуг пополнения. Перед использованием услуги пополнения внимательно прочитайте все содержание этого соглашения. Если вы не согласны с каким-либо содержанием этого соглашения или не можете точно понять значение соответствующих условий, не выполняйте операции пополнения.',
  'rechargeAgreement.section1.content2': 'Нажимая "Согласен" или выполняя операции пополнения, вы указываете, что прочитали, поняли и приняли все содержание этого соглашения.',
  'rechargeAgreement.section2.title': 'II. Инструкции по Пополнению',
  'rechargeAgreement.section2.subtitle1': '2.1 Способы Пополнения',
  'rechargeAgreement.section2.content1': 'Платформа поддерживает следующие способы пополнения:',
  'rechargeAgreement.section2.method1': 'Alipay',
  'rechargeAgreement.section2.method2': 'WeChat Pay',
  'rechargeAgreement.section2.method3': 'Банковская Карта (UnionPay, Visa, MasterCard)',
  'rechargeAgreement.section2.method4': 'Криптовалюта USDT (ERC20/TRC20)',
  'rechargeAgreement.section2.subtitle2': '2.2 Валюта Пополнения',
  'rechargeAgreement.section2.content2': 'Платформа поддерживает пополнение следующими валютами: CNY, USD, USDT. Между разными валютами может быть конвертация обменного курса, и конкретный обменный курс зависит от обменного курса в реальном времени на момент пополнения.',
  'rechargeAgreement.section2.subtitle3': '2.3 Лимиты Пополнения',
  'rechargeAgreement.section2.limit1': 'Минимальное единоразовое пополнение: 1 юань (или эквивалент в других валютах)',
  'rechargeAgreement.section2.limit2': 'Максимальное единоразовое пополнение: 50 000 юаней (или эквивалент в других валютах)',
  'rechargeAgreement.section2.limit3': 'Дневной накопительный лимит пополнения: 100 000 юаней (или эквивалент в других валютах)',
  'rechargeAgreement.section2.note': 'Примечание: Лимиты пополнения могут различаться в зависимости от способа оплаты, уровня счета и других факторов. Подробности см. на странице пополнения.',
  'rechargeAgreement.section3.title': 'III. Поступление Пополнения',
  'rechargeAgreement.section3.subtitle1': '3.1 Время Поступления',
  'rechargeAgreement.section3.time1': 'Alipay, WeChat Pay: Поступление в реальном времени',
  'rechargeAgreement.section3.time2': 'Банковская Карта: 1-3 рабочих дня',
  'rechargeAgreement.section3.time3': 'USDT: В зависимости от времени подтверждения блокчейна, обычно 10-30 минут',
  'rechargeAgreement.section3.subtitle2': '3.2 Обработка Исключений',
  'rechargeAgreement.section3.content1': 'Если пополнение не поступило вовремя, сохраните платежное подтверждение и немедленно свяжитесь со службой поддержки. Платформа обработает вашу проблему с пополнением как можно скорее после проверки.',
  'rechargeAgreement.section4.title': 'IV. Политика Возврата',
  'rechargeAgreement.section4.important': 'Важно: После успешного пополнения баланс счета не поддерживает прямой возврат. Баланс может использоваться только для потребления услуг в рамках платформы.',
  'rechargeAgreement.section4.subtitle1': '4.1 Условия Возврата',
  'rechargeAgreement.section4.content1': 'Вы можете запросить возврат в следующих случаях:',
  'rechargeAgreement.section4.refund1': 'Дублирование пополнения из-за сбоя системы платформы',
  'rechargeAgreement.section4.refund2': 'Служба недоступна по причинам платформы, и баланс счета не был потрачен',
  'rechargeAgreement.section4.refund3': 'Другие особые обстоятельства, одобренные платформой после проверки',
  'rechargeAgreement.section4.subtitle2': '4.2 Процесс Возврата',
  'rechargeAgreement.section4.process1': 'Подать заявку на возврат и объяснить причину',
  'rechargeAgreement.section4.process2': 'Проверка платформы (обычно 3-7 рабочих дней)',
  'rechargeAgreement.section4.process3': 'После одобрения возврат будет возвращен на ваш платежный счет',
  'rechargeAgreement.section5.title': 'V. Безопасность Счета',
  'rechargeAgreement.section5.content1': 'Вы несете ответственность за надлежащее хранение информации об учетной записи и пароля. Платформа не несет ответственности за убытки, вызванные кражей учетной записи или утечкой пароля из-за ваших собственных причин.',
  'rechargeAgreement.section5.content2': 'Если вы обнаружите аномалии в учетной записи, немедленно свяжитесь со службой поддержки и измените пароль. Платформа поможет вам решить связанные проблемы.',
  'rechargeAgreement.section6.title': 'VI. Отказ от Ответственности',
  'rechargeAgreement.section6.disclaimer1': 'Платформа не несет ответственности за перерывы в обслуживании, вызванные форс-мажором (таким как стихийные бедствия, война, действия правительства и т.д.)',
  'rechargeAgreement.section6.disclaimer2': 'Для проблем с пополнением, вызванных сбоями сторонних платежных платформ, платформа поможет в обработке, но не несет прямой ответственности',
  'rechargeAgreement.section6.disclaimer3': 'Убытки, вызванные нарушениями пользователем этого соглашения или соответствующих законов и правил, будут нести сами пользователи',
  'rechargeAgreement.section7.title': 'VII. Изменение Соглашения',
  'rechargeAgreement.section7.content1': 'Платформа имеет право изменять это соглашение в соответствии с потребностями развития бизнеса. После изменения соглашения оно будет объявлено в заметном месте на платформе. Если вы продолжите использовать услугу пополнения, это считается принятием измененного соглашения.',
  'rechargeAgreement.section8.title': 'VIII. Контактная Информация',
  'rechargeAgreement.section8.content1': 'Если у вас есть вопросы об этом соглашении, или вам нужно запросить возврат или обработать проблемы с пополнением, свяжитесь с нами следующими способами:',
  'rechargeAgreement.section8.contact1': 'Электронная почта службы поддержки: support@example.com',
  'rechargeAgreement.section8.contact2': 'Онлайн-служба поддержки: Рабочие дни 9:00-18:00',
  'rechargeAgreement.section8.contact3': 'Центр помощи: Просмотр FAQ',
  // Интернационализация профиля
  'profile.editProfile': 'Редактировать Профиль',
  'profile.creditScore': 'Кредитный Рейтинг',
  'profile.level': 'Уровень',
  'profile.balance': 'Баланс',
  'profile.tab.basic': 'Основная Информация',
  'profile.tab.account': 'Активы Аккаунта',
  'profile.section.personal': 'Личная Информация',
  'profile.section.contact': 'Контакт',
  'profile.section.wallet': 'Кошелек USDT',
  'profile.label.username': 'Имя Пользователя',
  'profile.label.realName': 'Настоящее Имя',
  'profile.label.accountStatus': 'Статус Аккаунта',
  'profile.label.phone': 'Номер Телефона',
  'profile.label.email': 'Email',
  'profile.label.registerTime': 'Время Регистрации',
  'profile.label.availableBalance': 'Доступный Баланс',
  'profile.label.frozenAmount': 'Замороженная Сумма',
  'profile.value.notVerified': 'Не Верифицирован',
  'profile.value.notBound': 'Не Привязан',
  'profile.value.noAddress': 'Нет Адреса TRC20',
  'profile.value.noDescription': 'Этот человек ленивый и ничего не написал',
  'profile.status.normal': 'Нормальный',
  'profile.status.disabled': 'Отключен',
  'profile.tooltip.verified': 'Верифицирован',
  'profile.tooltip.unverified': 'Верифицировать Сейчас',
  'profile.banner.construction': 'Эта страница находится в разработке...',
  'profile.modal.title': 'Редактировать Профиль',
  'profile.modal.cancel': 'Отмена',
  'profile.modal.save': 'Сохранить Изменения',
  'profile.modal.avatarSection': 'Настройки Аватара',
  'profile.modal.basicSection': 'Основная Информация',
  'profile.modal.contactSection': 'Контактная Информация',
  'profile.modal.changeAvatar': 'Изменить Аватар',
  'profile.modal.avatarHint': 'Поддерживаются форматы JPG, PNG, максимум 2MB',
  'profile.modal.nickname': 'Никнейм',
  'profile.modal.nicknamePlaceholder': 'Введите ваш никнейм',
  'profile.modal.description': 'Биография',
  'profile.modal.descriptionPlaceholder': 'Представьтесь одним предложением...',
  'profile.modal.phone': 'Телефон',
  'profile.modal.email': 'Email',
  'profile.message.avatarSizeLimit': 'Размер изображения не может превышать 2MB',
  'profile.message.avatarUploadSuccess': 'Аватар успешно загружен',
  'profile.message.saveSuccess': 'Успешно сохранено',
  'profile.message.saveFailed': 'Не удалось сохранить',
  'profile.message.uploadAvatarFailed': 'Не удалось загрузить аватар',
  'profile.message.operationFailed': 'Операция не удалась',
  'privacyPreferences.title': 'Настройки Конфиденциальности',
  'privacyPreferences.description': 'Управляйте настройками конфиденциальности и контролируйте, как мы собираем и используем ваши данные',
  'privacyPreferences.back': 'Назад',
  'privacyPreferences.save': 'Сохранить Настройки',
  'privacyPreferences.saveSuccess': 'Настройки конфиденциальности успешно сохранены',
  'privacyPreferences.saveError': 'Не удалось сохранить, попробуйте позже',
  'privacyPreferences.required': 'Обязательно',
  'privacyPreferences.info': 'Ваши настройки конфиденциальности будут сохранены локально и автоматически применены при следующем посещении. Войдите, чтобы синхронизировать настройки с облаком.',
  'privacyPreferences.info.loggedIn': 'Ваши настройки конфиденциальности будут сохранены в вашей учетной записи и синхронизированы на всех устройствах. Вы можете вернуться на эту страницу, чтобы изменить эти настройки в любое время.',
  'cookieBanner.message': 'Мы используем cookie и локальное хранилище для входа, темы и основных функций. Продолжая, вы соглашаетесь с нашей политикой конфиденциальности.',
  'cookieBanner.acceptAll': 'Принять все',
  'cookieBanner.essentialOnly': 'Только необходимые',
  'cookieBanner.settings': 'Настройки',
  'privacyPreferences.cookies.title': 'Настройки Cookie',
  'privacyPreferences.cookies.description': 'Cookie помогают нам предоставлять лучший сервис. Вы можете выбрать, принимать или отклонять определенные типы cookie.',
  'privacyPreferences.cookies.essential': 'Необходимые Cookie',
  'privacyPreferences.cookies.essential.desc': 'Эти cookie необходимы для правильной работы веб-сайта и не могут быть отключены. Обычно они используются для безопасности, входа в систему и базовой функциональности.',
  'privacyPreferences.cookies.functional': 'Функциональные Cookie',
  'privacyPreferences.cookies.functional.desc': 'Эти cookie позволяют веб-сайту запоминать ваши выборы и предоставлять расширенную функциональность и персонализированный опыт.',
  'privacyPreferences.cookies.analytics': 'Аналитические Cookie',
  'privacyPreferences.cookies.analytics.desc': 'Эти cookie помогают нам понять, как посетители используют веб-сайт, чтобы мы могли улучшить наши услуги.',
  'privacyPreferences.cookies.marketing': 'Маркетинговые Cookie',
  'privacyPreferences.cookies.marketing.desc': 'Эти cookie используются для отслеживания вашей активности просмотра, чтобы показывать вам релевантную рекламу и контент.',
  'privacyPreferences.data.title': 'Настройки Сбора Данных',
  'privacyPreferences.data.description': 'Контролируйте, как мы собираем и используем ваши данные для улучшения сервиса.',
  'privacyPreferences.data.collection': 'Сбор Данных',
  'privacyPreferences.data.collection.desc': 'Разрешите нам собирать необходимые данные об использовании для предоставления и улучшения услуг.',
  'privacyPreferences.data.analytics': 'Анализ Данных',
  'privacyPreferences.data.analytics.desc': 'Разрешите нам анализировать ваши модели использования для оптимизации производительности сервиса и пользовательского опыта.',
  'privacyPreferences.data.personalization': 'Персонализация',
  'privacyPreferences.data.personalization.desc': 'Разрешите нам предоставлять персонализированный контент и рекомендации на основе ваших предпочтений и привычек использования.',
  'privacyPreferences.marketing.title': 'Маркетинговые Настройки',
  'privacyPreferences.marketing.description': 'Выберите типы маркетинговых сообщений, которые вы хотите получать.',
  'privacyPreferences.marketing.emails': 'Маркетинговые Email',
  'privacyPreferences.marketing.emails.desc': 'Получайте уведомления по электронной почте об обновлениях продуктов, акциях и специальных предложениях.',
  'privacyPreferences.marketing.sms': 'Маркетинговые SMS',
  'privacyPreferences.marketing.sms.desc': 'Получайте SMS-уведомления о важных обновлениях и акциях.',
  'privacyPreferences.marketing.push': 'Push-уведомления',
  'privacyPreferences.marketing.push.desc': 'Получайте push-уведомления браузера, включая обновления продуктов и важные сообщения.',
  'privacyPreferences.thirdParty.title': 'Обмен Данными с Третьими Сторонами',
  'privacyPreferences.thirdParty.description': 'Контролируйте, разрешать ли обмен вашими данными с поставщиками услуг третьих сторон.',
  'privacyPreferences.thirdParty.sharing': 'Обмен Данными с Третьими Сторонами',
  'privacyPreferences.thirdParty.sharing.desc': 'Разрешите нам делиться анонимизированными данными об использовании с доверенными поставщиками услуг третьих сторон для улучшения услуг.',
  
  // Политика конфиденциальности
  'privacyPolicy.title': 'Политика конфиденциальности',
  'privacyPolicy.lastUpdated': 'Последнее обновление: {date}',
  'privacyPolicy.intro1': 'Эта Политика конфиденциальности описывает, как платформа AIMATEX (далее "мы" или "эта платформа") собирает, использует, хранит и защищает вашу личную информацию при использовании наших услуг, а также ваши права на конфиденциальность. Мы очень серьезно относимся к защите вашей конфиденциальности. Пожалуйста, внимательно прочитайте эту Политику конфиденциальности.',
  'privacyPolicy.intro2': 'Используя наши услуги, вы соглашаетесь с этой Политикой конфиденциальности. Если вы не согласны с какой-либо частью этой Политики конфиденциальности, пожалуйста, не используйте наши услуги.',
  'privacyPolicy.section1.title': 'I. Информация, которую мы собираем',
  'privacyPolicy.section1.1.title': '1.1 Информация, которую вы предоставляете',
  'privacyPolicy.section1.1.intro': 'При использовании этого сервиса вам может потребоваться предоставить следующую информацию:',
  'privacyPolicy.section1.1.item1.label': 'Информация об аккаунте',
  'privacyPolicy.section1.1.item1.desc': 'Имя пользователя, адрес электронной почты, пароль, номер телефона и т.д.',
  'privacyPolicy.section1.1.item2.label': 'Информация профиля',
  'privacyPolicy.section1.1.item2.desc': 'Аватар, никнейм, биография и т.д. (необязательно)',
  'privacyPolicy.section1.1.item3.label': 'Платежная информация',
  'privacyPolicy.section1.1.item3.desc': 'Способы оплаты, адрес для выставления счетов и т.д. (для обработки платежей)',
  'privacyPolicy.section1.1.item4.label': 'Сгенерированный контент',
  'privacyPolicy.section1.1.item4.desc': 'Текстовые подсказки, референсные изображения, сгенерированные видео, музыка, изображения, 3D-модели и т.д., которые вы загружаете',
  'privacyPolicy.section1.2.title': '1.2 Автоматически собираемая информация',
  'privacyPolicy.section1.2.intro': 'При использовании этого сервиса мы можем автоматически собирать следующую информацию:',
  'privacyPolicy.section1.2.item1.label': 'Информация об устройстве',
  'privacyPolicy.section1.2.item1.desc': 'Тип устройства, операционная система, тип и версия браузера, идентификаторы устройства и т.д.',
  'privacyPolicy.section1.2.item2.label': 'Данные об использовании',
  'privacyPolicy.section1.2.item2.desc': 'Время доступа, посещенные страницы, используемые функции, записи операций и т.д.',
  'privacyPolicy.section1.2.item3.label': 'Сетевая информация',
  'privacyPolicy.section1.2.item3.desc': 'IP-адрес, тип сети, сетевой оператор и т.д.',
  'privacyPolicy.section1.2.item4.label': 'Информация журнала',
  'privacyPolicy.section1.2.item4.desc': 'Журналы ошибок, данные о производительности и т.д.',
  'privacyPolicy.section1.3.title': '1.3 Cookie и аналогичные технологии',
  'privacyPolicy.section1.3.intro': 'Мы используем cookie и аналогичные технологии для:',
  'privacyPolicy.section1.3.item1': 'Поддержания вашего статуса входа',
  'privacyPolicy.section1.3.item2': 'Запоминания ваших предпочтений (таких как язык, тема и т.д.)',
  'privacyPolicy.section1.3.item3': 'Анализа использования сервиса для улучшения качества сервиса',
  'privacyPolicy.section1.3.item4': 'Предоставления персонализированного опыта',
  'privacyPolicy.section1.3.note': 'Вы можете отказаться от cookie через настройки браузера, но это может повлиять на использование некоторых функций.',
  'privacyPolicy.section2.title': 'II. Цель использования информации',
  'privacyPolicy.section2.intro': 'Мы собираем и используем вашу информацию для следующих целей:',
  'privacyPolicy.section2.item1.label': 'Предоставление услуг',
  'privacyPolicy.section2.item1.desc': 'Обработка ваших запросов на генерацию контента (видео, музыка, изображения, 3D-модели и т.д.), управление вашим аккаунтом и работами и т.д.',
  'privacyPolicy.section2.item2.label': 'Улучшение услуг',
  'privacyPolicy.section2.item2.desc': 'Анализ использования, оптимизация производительности сервиса и пользовательского опыта',
  'privacyPolicy.section2.item3.label': 'Управление аккаунтом',
  'privacyPolicy.section2.item3.desc': 'Проверка личности, обработка платежей, отправка уведомлений и т.д.',
  'privacyPolicy.section2.item4.label': 'Безопасность',
  'privacyPolicy.section2.item4.desc': 'Обнаружение и предотвращение мошенничества, злоупотреблений, угроз безопасности и т.д.',
  'privacyPolicy.section2.item5.label': 'Поддержка клиентов',
  'privacyPolicy.section2.item5.desc': 'Ответы на ваши запросы, обработка жалоб и отзывов и т.д.',
  'privacyPolicy.section2.item6.label': 'Правовое соответствие',
  'privacyPolicy.section2.item6.desc': 'Соблюдение правовых требований, сотрудничество с правоохранительными органами и т.д.',
  'privacyPolicy.section3.title': 'III. Обмен и раскрытие информации',
  'privacyPolicy.section3.1.title': '3.1 Мы не продаем вашу личную информацию',
  'privacyPolicy.section3.1.content': 'Мы не продаем, не сдаем в аренду и не обмениваем вашу личную информацию третьим лицам.',
  'privacyPolicy.section3.2.title': '3.2 Поставщики услуг',
  'privacyPolicy.section3.2.intro': 'Мы можем делиться информацией со следующими типами поставщиков услуг:',
  'privacyPolicy.section3.2.item1.label': 'Поставщики облачных услуг',
  'privacyPolicy.section3.2.item1.desc': 'Для хранения и обработки данных',
  'privacyPolicy.section3.2.item2.label': 'Поставщики платежных услуг',
  'privacyPolicy.section3.2.item2.desc': 'Для обработки платежных транзакций',
  'privacyPolicy.section3.2.item3.label': 'Поставщики аналитических услуг',
  'privacyPolicy.section3.2.item3.desc': 'Для анализа использования сервиса',
  'privacyPolicy.section3.2.item4.label': 'Поставщики услуг поддержки клиентов',
  'privacyPolicy.section3.2.item4.desc': 'Для предоставления поддержки клиентов',
  'privacyPolicy.section3.2.note': 'Эти поставщики услуг могут использовать информацию только для предоставления нам услуг, а не для других целей.',
  'privacyPolicy.section3.3.title': '3.3 Правовые требования',
  'privacyPolicy.section3.3.intro': 'Мы можем раскрыть вашу информацию в следующих обстоятельствах:',
  'privacyPolicy.section3.3.item1': 'Соблюдение законов, нормативных актов, судебных решений или государственных требований',
  'privacyPolicy.section3.3.item2': 'Защита наших прав, собственности или безопасности',
  'privacyPolicy.section3.3.item3': 'Предотвращение или расследование возможной незаконной деятельности',
  'privacyPolicy.section3.3.item4': 'Защита безопасности пользователей или общественности',
  'privacyPolicy.section3.4.title': '3.4 Передача бизнеса',
  'privacyPolicy.section3.4.content': 'В случае слияния, поглощения или передачи активов ваша информация может быть передана. Мы уведомим вас до передачи.',
  'privacyPolicy.section4.title': 'IV. Хранение и безопасность информации',
  'privacyPolicy.section4.1.title': '4.1 Место хранения',
  'privacyPolicy.section4.1.content': 'Ваша информация может храниться на серверах, расположенных внутри или за пределами Китайской Народной Республики. Мы примем соответствующие меры для обеспечения безопасности информации.',
  'privacyPolicy.section4.2.title': '4.2 Период хранения',
  'privacyPolicy.section4.2.intro': 'Мы храним вашу информацию только в течение необходимого периода:',
  'privacyPolicy.section4.2.item1': 'Информация об аккаунте: в течение срока действия вашего аккаунта и в течение периода после отмены',
  'privacyPolicy.section4.2.item2': 'Сгенерированный контент: хранится в соответствии с вашими настройками или правовыми требованиями',
  'privacyPolicy.section4.2.item3': 'Данные об использовании: обычно хранятся в течение более короткого периода для анализа и улучшения сервиса',
  'privacyPolicy.section4.3.title': '4.3 Меры безопасности',
  'privacyPolicy.section4.3.intro': 'Мы принимаем следующие меры безопасности для защиты вашей информации:',
  'privacyPolicy.section4.3.item1': 'Зашифрованная передача и хранение',
  'privacyPolicy.section4.3.item2': 'Контроль доступа и аутентификация',
  'privacyPolicy.section4.3.item3': 'Регулярные аудиты безопасности и сканирование уязвимостей',
  'privacyPolicy.section4.3.item4': 'Обучение сотрудников и соглашения о конфиденциальности',
  'privacyPolicy.section4.3.note': 'Обратите внимание, что никакие меры безопасности не являются на 100% безопасными. Мы не можем гарантировать абсолютную безопасность информации.',
  'privacyPolicy.section5.title': 'V. Ваши права',
  'privacyPolicy.section5.intro': 'В соответствии с применимыми законами и нормативными актами вы имеете следующие права:',
  'privacyPolicy.section5.item1.label': 'Право доступа',
  'privacyPolicy.section5.item1.desc': 'Просмотр вашей личной информации, которой мы владеем',
  'privacyPolicy.section5.item2.label': 'Право на исправление',
  'privacyPolicy.section5.item2.desc': 'Исправление неточной или неполной информации',
  'privacyPolicy.section5.item3.label': 'Право на удаление',
  'privacyPolicy.section5.item3.desc': 'Требовать удаления вашей личной информации (кроме случаев, когда закон требует хранения)',
  'privacyPolicy.section5.item4.label': 'Право отозвать согласие',
  'privacyPolicy.section5.item4.desc': 'Отозвать ваше согласие на обработку информации',
  'privacyPolicy.section5.item5.label': 'Право на переносимость данных',
  'privacyPolicy.section5.item5.desc': 'Получить копию вашей личной информации',
  'privacyPolicy.section5.item6.label': 'Право на возражение',
  'privacyPolicy.section5.item6.desc': 'Возражать против определенных видов обработки информации',
  'privacyPolicy.section5.note': 'Для осуществления вышеуказанных прав, пожалуйста, свяжитесь с нами через контактную информацию в конце этой Политики конфиденциальности.',
  'privacyPolicy.section6.title': 'VI. Защита несовершеннолетних',
  'privacyPolicy.section6.content1': 'Этот сервис в основном предназначен для пользователей старше 18 лет. Если вам меньше 18 лет, используйте этот сервис с согласия и под надзором вашего опекуна.',
  'privacyPolicy.section6.content2': 'Если мы обнаружим, что собрали личную информацию пользователей младше 18 лет без согласия опекуна, мы удалим соответствующую информацию как можно скорее.',
  'privacyPolicy.section7.title': 'VII. Ссылки третьих сторон',
  'privacyPolicy.section7.content': 'Этот сервис может содержать ссылки на веб-сайты третьих сторон. Мы не несем ответственности за практики конфиденциальности этих веб-сайтов третьих сторон. При посещении этих сайтов ознакомьтесь с их политиками конфиденциальности.',
  'privacyPolicy.section8.title': 'VIII. Изменения в Политике конфиденциальности',
  'privacyPolicy.section8.content1': 'Мы можем время от времени обновлять эту Политику конфиденциальности. Существенные изменения будут уведомлены вам как минимум за 30 дней до их вступления в силу. Продолжение использования сервиса означает ваше согласие с обновленной Политикой конфиденциальности.',
  'privacyPolicy.section8.content2': 'Мы обновим дату "Последнее обновление" в верхней части этой страницы и уведомим вас о важных изменениях по электронной почте или через уведомления в приложении.',
  'privacyPolicy.section9.title': 'IX. Свяжитесь с нами',
  'privacyPolicy.section9.intro': 'Если у вас есть вопросы, комментарии или жалобы по поводу этой Политики конфиденциальности, пожалуйста, свяжитесь с нами следующими способами:',
  'privacyPolicy.section9.email': 'Электронная почта: {email}',
  'privacyPolicy.section9.hours': 'Часы работы службы поддержки: рабочие дни 9:00-18:00',
  'privacyPolicy.section9.response': 'Мы ответим на ваш запрос в разумные сроки.',
  
  // Условия использования
  'termsOfService.title': 'Условия использования',
  'termsOfService.lastUpdated': 'Последнее обновление: {date}',
  'termsOfService.intro': 'Перед использованием наших услуг внимательно прочитайте эти Условия использования. Получая доступ к платформе AIMATEX или используя ее (далее "эта платформа" или "сервис"), вы соглашаетесь быть связанными этими Условиями использования. Если вы не согласны с какой-либо частью этих Условий использования, пожалуйста, не используйте наши услуги.',
  'termsOfService.section1.title': 'I. Определения и толкование',
  'termsOfService.section1.1.title': '1.1 Определения',
  'termsOfService.section1.1.intro': 'В этих Условиях использования, если контекст не требует иного, следующие термины имеют следующие значения:',
  'termsOfService.section1.1.item1.label': '"Платформа" или "Эта платформа"',
  'termsOfService.section1.1.item1.desc': 'Относится к платформе сервиса генерации видео AIMATEX, включая, но не ограничиваясь, веб-сайтами, мобильными приложениями и связанными услугами.',
  'termsOfService.section1.1.item2.label': '"Мы", "Наш", "Компания"',
  'termsOfService.section1.1.item2.desc': 'Относится к оператору платформы AIMATEX, а именно ProTX Team.',
  'termsOfService.section1.1.item3.label': '"Вы", "Пользователь"',
  'termsOfService.section1.1.item3.desc': 'Относится к любому физическому лицу, компании или другому юридическому лицу, которое получает доступ к этому сервису или использует его.',
  'termsOfService.section1.1.item4.label': '"Сервис"',
  'termsOfService.section1.1.item4.desc': 'Относится ко всем функциям и услугам, предоставляемым этой платформой, включая, но не ограничиваясь, генерацией видео, музыки, изображений, 3D-моделей ИИ и другого контента, выбором моделей, управлением работами, управлением аккаунтами пользователей и т.д.',
  'termsOfService.section1.1.item5.label': '"Контент"',
  'termsOfService.section1.1.item5.desc': 'Относится к любому тексту, изображениям, видео, аудио и другим материалам, загруженным, сгенерированным, созданным или совместно используемым пользователями через эту платформу.',
  'termsOfService.section1.1.item6.label': '"Сгенерированный контент"',
  'termsOfService.section1.1.item6.desc': 'Относится к видео, музыке, изображениям, 3D-моделям и другим работам, сгенерированным пользователями с использованием моделей ИИ этой платформы.',
  'termsOfService.section1.1.item7.label': '"Аккаунт"',
  'termsOfService.section1.1.item7.desc': 'Относится к учетной записи пользователя, зарегистрированной пользователями на этой платформе.',
  'termsOfService.section2.title': 'II. Описание сервиса',
  'termsOfService.section2.1.title': '2.1 Содержание сервиса',
  'termsOfService.section2.1.intro': 'Эта платформа предоставляет комплексные услуги генерации контента ИИ, включая, но не ограничиваясь:',
  'termsOfService.section2.1.item1': 'Генерация текста в медиа (видео, музыка, изображения, 3D-модели и т.д.) (Text-to-Media)',
  'termsOfService.section2.1.item2': 'Генерация изображения в медиа (видео, 3D-модели и т.д.) (Image-to-Media)',
  'termsOfService.section2.1.item3': 'Управление и отображение различных сгенерированных работ',
  'termsOfService.section2.1.item4': 'Выбор и управление моделями',
  'termsOfService.section2.1.item5': 'Аккаунты пользователей и личный центр',
  'termsOfService.section2.1.item6': 'Услуги подписки и оплаты',
  'termsOfService.section2.2.title': '2.2 Изменения в сервисе',
  'termsOfService.section2.2.content': 'Мы оставляем за собой право изменять, приостанавливать или прекращать часть или весь сервис в любое время без предварительного уведомления. Мы не несем ответственности за любые убытки, вызванные изменениями в сервисе.',
  'termsOfService.section3.title': 'III. Аккаунты пользователей',
  'termsOfService.section3.1.title': '3.1 Регистрация аккаунта',
  'termsOfService.section3.1.intro': 'Использование этого сервиса требует регистрации аккаунта. При регистрации вы соглашаетесь:',
  'termsOfService.section3.1.item1': 'Предоставлять правдивую, точную и полную информацию для регистрации',
  'termsOfService.section3.1.item2': 'Своевременно обновлять информацию для регистрации, чтобы она оставалась правдивой, точной и полной',
  'termsOfService.section3.1.item3': 'Нести ответственность за все действия под вашим аккаунтом',
  'termsOfService.section3.1.item4': 'Хранить пароль вашего аккаунта в безопасности и не передавать, продавать или одалживать ваш аккаунт другим',
  'termsOfService.section3.2.title': '3.2 Ограничение по возрасту',
  'termsOfService.section3.2.content': 'Вам должно быть не менее 18 лет, чтобы использовать этот сервис. Если вам меньше 18 лет, используйте этот сервис с согласия и под надзором вашего опекуна.',
  'termsOfService.section3.3.title': '3.3 Безопасность аккаунта',
  'termsOfService.section3.3.content': 'Вы несете ответственность за поддержание безопасности вашего аккаунта. Если вы обнаружите, что ваш аккаунт был скомпрометирован или существует уязвимость безопасности, немедленно сообщите нам. Мы не несем ответственности за убытки, вызванные вашей неспособностью должным образом защитить информацию вашего аккаунта.',
  'termsOfService.section4.title': 'IV. Правила использования',
  'termsOfService.section4.1.title': '4.1 Запрещенные действия',
  'termsOfService.section4.1.intro': 'При использовании этого сервиса вы не должны:',
  'termsOfService.section4.1.item1': 'Генерировать, загружать или делиться незаконным, вредным, угрожающим, оскорбительным, преследующим, клеветническим, вульгарным, непристойным контентом, нарушающим конфиденциальность или права интеллектуальной собственности других',
  'termsOfService.section4.1.item2': 'Генерировать или распространять ложную информацию, вводящий в заблуждение или вредоносный контент',
  'termsOfService.section4.1.item3': 'Использовать этот сервис для коммерческого мошенничества, отмывания денег или другой незаконной деятельности',
  'termsOfService.section4.1.item4': 'Мешать или разрушать нормальную работу этой платформы, включая, но не ограничиваясь использованием автоматизированных инструментов, краулеров, вирусов и т.д.',
  'termsOfService.section4.1.item5': 'Получать несанкционированный доступ к любым системам, данным или аккаунтам этой платформы',
  'termsOfService.section4.1.item6': 'Копировать, изменять, распространять, продавать или сдавать в аренду любую часть этой платформы',
  'termsOfService.section4.1.item7': 'Осуществлять обратную инженерию, декомпилировать или дизассемблировать любое программное обеспечение этой платформы',
  'termsOfService.section4.2.title': '4.2 Ответственность за контент',
  'termsOfService.section4.2.content': 'Вы несете полную ответственность за весь контент, сгенерированный, загруженный или совместно используемый через эту платформу. Мы не предварительно проверяем контент, созданный пользователями, но оставляем за собой право удалять нарушающий контент в любое время.',
  'termsOfService.section5.title': 'V. Интеллектуальная собственность',
  'termsOfService.section5.1.title': '5.1 Интеллектуальная собственность платформы',
  'termsOfService.section5.1.content': 'Все права интеллектуальной собственности этой платформы, включая, но не ограничиваясь товарными знаками, патентами, авторскими правами, коммерческими секретами и т.д., принадлежат нам или соответствующим правообладателям. Вы не можете использовать их без разрешения.',
  'termsOfService.section5.2.title': '5.2 Контент, созданный пользователем',
  'termsOfService.section5.2.content': 'Права интеллектуальной собственности на контент, который вы генерируете через эту платформу, принадлежат вам. Однако вы предоставляете нам неисключительное, всемирное, бесплатное и подлежащее сублицензированию право использовать, отображать и распространять ваш контент для предоставления и улучшения услуг.',
  'termsOfService.section5.3.title': '5.3 Модели ИИ',
  'termsOfService.section5.3.content': 'Права интеллектуальной собственности на модели ИИ (включая модели Sora), используемые этой платформой, принадлежат их разработчикам. Вы не можете копировать, изменять или распространять эти модели.',
  'termsOfService.section6.title': 'VI. Платные услуги',
  'termsOfService.section6.1.title': '6.1 Модели оплаты',
  'termsOfService.section6.1.content': 'Эта платформа предлагает две модели оплаты: подписка и оплата за использование. Конкретные цены и методы выставления счетов подлежат объявлениям платформы.',
  'termsOfService.section6.2.title': '6.2 Оплата',
  'termsOfService.section6.2.content': 'Вы соглашаетесь платить сборы за услуги в соответствии с ценами, объявленными платформой. Все сборы рассчитываются в юанях или других валютах, поддерживаемых платформой. После успешной оплаты сборы не подлежат возврату, если иное не предусмотрено законом или мы не дали других обязательств.',
  'termsOfService.section6.3.title': '6.3 Политика возврата',
  'termsOfService.section6.3.content': 'Если иное не предусмотрено законом или мы не дали других обязательств, оплаченные сборы не подлежат возврату. Если сервис не может быть использован нормально из-за проблем платформы, мы предоставим возврат или компенсацию в соответствии с фактической ситуацией.',
  'termsOfService.section7.title': 'VII. Доступность сервиса',
  'termsOfService.section7.1.title': '7.1 Прерывание сервиса',
  'termsOfService.section7.1.intro': 'Мы не несем ответственности за прерывания сервиса, вызванные следующими причинами:',
  'termsOfService.section7.1.item1': 'Обслуживание, обновление или сбой системы',
  'termsOfService.section7.1.item2': 'Факторы непреодолимой силы (такие как стихийные бедствия, войны, забастовки и т.д.)',
  'termsOfService.section7.1.item3': 'Проблемы с поставщиками услуг третьих сторон',
  'termsOfService.section7.1.item4': 'Сбои сети или проблемы с устройствами пользователя',
  'termsOfService.section7.2.title': '7.2 Гарантия сервиса',
  'termsOfService.section7.2.content': 'Мы стремимся обеспечить стабильность и доступность сервиса, но не гарантируем, что сервис не будет прерван, безошибочен или полностью безопасен. Сервис предоставляется "как есть" и "как доступно" без каких-либо явных или подразумеваемых гарантий.',
  'termsOfService.section8.title': 'VIII. Защита конфиденциальности',
  'termsOfService.section8.content': 'Мы серьезно относимся к защите вашей конфиденциальности. Для получения информации о том, как мы собираем, используем и защищаем вашу личную информацию, см. нашу Политику конфиденциальности. Использование этого сервиса означает ваше согласие с нашей Политикой конфиденциальности.',
  'termsOfService.section9.title': 'IX. Ограничение ответственности',
  'termsOfService.section9.1.title': '9.1 Объем ответственности',
  'termsOfService.section9.1.intro': 'В максимальной степени, разрешенной законом, мы не несем ответственности за любой прямой, косвенный, случайный, особый или последующий ущерб, возникающий в результате использования или невозможности использования этого сервиса, включая, но не ограничиваясь:',
  'termsOfService.section9.1.item1': 'Потеря прибыли, потеря данных или другие экономические потери',
  'termsOfService.section9.1.item2': 'Прерывание бизнеса',
  'termsOfService.section9.1.item3': 'Травма или потеря имущества',
  'termsOfService.section9.1.item4': 'Нарушение конфиденциальности',
  'termsOfService.section9.2.title': '9.2 Предел ответственности',
  'termsOfService.section9.2.content': 'Наша общая ответственность не превышает общую сумму, которую вы фактически заплатили за этот сервис за последние 12 месяцев, или 100 долларов США (в зависимости от того, что больше).',
  'termsOfService.section10.title': 'X. Прекращение сервиса',
  'termsOfService.section10.1.title': '10.1 Прекращение пользователем',
  'termsOfService.section10.1.content': 'Вы можете прекратить использование этого сервиса и отменить свой аккаунт в любое время.',
  'termsOfService.section10.2.title': '10.2 Прекращение платформой',
  'termsOfService.section10.2.intro': 'Мы имеем право немедленно прекратить или приостановить ваш аккаунт и сервис в следующих обстоятельствах:',
  'termsOfService.section10.2.item1': 'Вы нарушаете эти Условия использования',
  'termsOfService.section10.2.item2': 'Вы занимаетесь незаконной деятельностью',
  'termsOfService.section10.2.item3': 'Ваш аккаунт не использовался в течение длительного периода',
  'termsOfService.section10.2.item4': 'Правовые или нормативные требования',
  'termsOfService.section10.2.note': 'После прекращения сервиса вы не сможете получить доступ к своему аккаунту и сгенерированному контенту, если иное не предусмотрено законом.',
  'termsOfService.section11.title': 'XI. Разрешение споров',
  'termsOfService.section11.1.title': '11.1 Переговоры',
  'termsOfService.section11.1.content': 'Если возникает спор, обе стороны должны сначала попытаться разрешить его путем дружественных переговоров.',
  'termsOfService.section11.2.title': '11.2 Применимое право',
  'termsOfService.section11.2.content': 'Эти Условия использования регулируются законами Китайской Народной Республики. Если обе стороны не могут разрешить спор путем переговоров, он будет передан в народный суд с юрисдикцией в нашем местоположении.',
  'termsOfService.section12.title': 'XII. Другие положения',
  'termsOfService.section12.1.title': '12.1 Изменение условий',
  'termsOfService.section12.1.content': 'Мы оставляем за собой право изменять эти Условия использования в любое время. Существенные изменения будут уведомлены вам как минимум за 30 дней до их вступления в силу. Продолжение использования сервиса означает ваше согласие с измененными условиями.',
  'termsOfService.section12.2.title': '12.2 Разделимость',
  'termsOfService.section12.2.content': 'Если какое-либо положение этих Условий использования признано недействительным или неисполнимым, это не влияет на действительность других положений.',
  'termsOfService.section12.3.title': '12.3 Полное соглашение',
  'termsOfService.section12.3.content': 'Эти Условия использования составляют полное соглашение между вами и нами относительно использования этого сервиса, заменяя все предыдущие устные или письменные соглашения.',
  'termsOfService.section13.title': 'XIII. Свяжитесь с нами',
  'termsOfService.section13.intro': 'Если у вас есть вопросы об этих Условиях использования, пожалуйста, свяжитесь с нами следующими способами:',
  'termsOfService.section13.email': 'Электронная почта: {email}',
  'termsOfService.section13.hours': 'Часы работы службы поддержки: рабочие дни 9:00-18:00',
  
  // Footer
  'footer.brand.description': 'Предоставляет услуги генерации с помощью ИИ.',
  'footer.joinUs': 'Вакансии',
  'footer.product.title': 'Продукт',
  'footer.product.signup': 'Регистрация',
  'footer.product.login': 'Войти',
  'footer.product.workspace': 'Рабочее пространство',
  'footer.product.works': 'Мои работы',
  'footer.support.title': 'Поддержка',
  'footer.support.help': 'Центр помощи',
  'footer.support.about': 'О нас',
  'footer.support.feedback': 'Обратная связь',
  'footer.support.contact': 'Связаться с нами',
  'footer.legal.title': 'Правовая информация',
  'footer.legal.privacy': 'Политика конфиденциальности',
  'footer.legal.terms': 'Условия использования',
  'footer.legal.recharge': 'Соглашение о пополнении',
  'footer.resources.title': 'Ресурсы',
  'footer.resources.invite': 'Пригласить друзей',
  'footer.resources.account': 'Управление аккаунтом',
  'footer.resources.orders': 'Центр заказов',
  'footer.copyright': '© {year} {brand}. Все права защищены.',
  'footer.description': 'Эта платформа предоставляет услуги генерации с помощью ИИ',
  'footer.openRobotX.title': 'Open Robot X',
  'footer.openRobotX.description': 'Глобальная база данных гуманоидной робототехники с сравнением характеристик и отраслевыми аналитическими данными',
  'footer.openRobotX.visit': 'Посетить Open Robot X',
  'footer.ai2obj.title': 'ai2obj',
  'footer.ai2obj.description': 'Комплексная платформа генерации с ИИ для создания разнообразного цифрового контента',
  'footer.aimatexMusic.title': 'AIMATEX-MUSIC',
  'footer.aimatexMusic.description': 'Облачная музыка: поиск, плейлисты, Now Playing и библиотека',
  
  // Страница цен
  'pricing.title': 'Выберите план, который вам подходит',
  'pricing.plan.basic.sub': 'Базовый',
  'pricing.plan.pro.sub': 'Про',
  'pricing.plan.team.sub': 'Команда',
  'pricing.plan.popular': 'ПОПУЛЯРНЫЙ',
  'pricing.plan.button.select': 'Выбрать план',
  'pricing.plan.button.subscribe': 'Подписаться сейчас',
  'pricing.plan.basic.videoQuota': '5/месяц',
  'pricing.plan.basic.videoDuration': '6-10с',
  'pricing.plan.basic.videoQuality': '720P',
  'pricing.plan.pro.videoQuota': '30/месяц',
  'pricing.plan.pro.videoDuration': '10-15с',
  'pricing.plan.pro.videoQuality': '1080P',
  'pricing.plan.team.videoQuota': '100/месяц',
  'pricing.plan.team.videoDuration': '10-15с',
  'pricing.plan.team.videoQuality': '1080P/4K',
  'pricing.feature.videoQuota': 'Квота генерации видео',
  'pricing.feature.videoDuration': 'Длительность видео',
  'pricing.feature.videoQuality': 'Качество видео',
  'pricing.feature.storyboard': 'Раскадровка',
  'pricing.feature.workflow': 'Рабочий процесс',
  'pricing.feature.priorityQueue': 'Приоритетная очередь',
  'pricing.feature.exclusiveChannel': 'Эксклюзивный канал',
  'pricing.feature.highestQuality': 'Режим максимального качества',
  'pricing.feature.sdImage': 'Генерация изображений SD',
  'pricing.feature.unlimited': 'Безлимитно',
  'pricing.feature.promptOptimization': 'Оптимизация промптов',
  'pricing.feature.imageSize': 'Размер изображения',
  'pricing.feature.storage': 'Место для хранения',
  'pricing.feature.commercialLicense': 'Коммерческая лицензия',
  'pricing.feature.apiAccess': 'Доступ к API',
  'pricing.then': 'затем',
  'cta.title': 'Начните создавать свои видео',
  'cta.description': 'Зарегистрируйтесь сейчас и превратите свое творчество в потрясающие видеоработы с помощью технологии ИИ',
  'cta.button': 'Начать бесплатно',
  'technology.coreArchitecture': 'ОСНОВНАЯ АРХИТЕКТУРА',
  'technology.workflowEngine.title': 'Визуальный движок рабочего процесса',
  'technology.workflowEngine.description': 'Поддержка визуального рабочего процесса скоро появится. Каждый узел - это точный контроль над творчеством.',
  'technology.node.checkpointLoader': 'Checkpoint Loader',
  'technology.node.clipTextPositive': 'CLIP Text (Positive)',
  'technology.node.clipTextNegative': 'CLIP Text (Negative)',
  'technology.node.ksamplerAdvanced': 'KSampler Advanced',
  'technology.node.vaeDecode': 'VAE Decode',
  'technology.node.previewImage': 'Preview Image',
  'technology.hud.systemResourceMonitor': 'Монитор системных ресурсов',
  'technology.hud.gpuVram': 'GPU VRAM',
  'technology.terminal.console': 'console — zsh',
  'technology.button.runWorkflow': 'Запустить рабочий процесс',
  'technology.button.running': 'Выполняется...',
  'technology.log.systemInitialized': '> Система инициализирована.',
  'technology.log.waitingForInput': '> Ожидание ввода пользователя...',
  'technology.log.loadingCheckpoint': 'Loading SDXL Checkpoint (fp16)...',
  'technology.log.tokenizingPrompt': 'Tokenizing positive prompt...',
  'technology.log.ksamplerSteps': 'KSampler: 30/30 steps (Euler A)',
  'technology.log.generationComplete': 'Generation complete.',
  'technology.benchmark.title': 'Окончательный тест производительности',
  'technology.benchmark.description': 'Для этого улучшения на 0,5 секунды мы переписали 30% базовых операторов.',
  'technology.benchmark.fps.title': 'Скорость генерации (FPS)',
  'technology.benchmark.fps.subtitle': 'Comparison @ 1080p',
  'technology.benchmark.vram.title': 'Оптимизация VRAM',
  'technology.benchmark.vram.subtitle': 'Lower is better',
  'technology.benchmark.productX': 'ProductX',
  'technology.benchmark.others': 'Others',
  'technology.benchmark.standard': 'Standard',
  'technology.galaxy.openEcology': 'ОТКРЫТАЯ ЭКОСИСТЕМА',
  'technology.galaxy.title': 'Бесконечная вселенная моделей',
  'technology.galaxy.description': 'Поддержка прямого подключения Civitai, тысячи моделей, загрузка одним кликом.',
  'technology.galaxy.autoSync': 'Автосинхронизация',
  
  // Страница обратной связи
  'feedback.leftPanel.title.line1': 'Мы слушаем',
  'feedback.leftPanel.title.line2': 'Ваш голос',
  'feedback.leftPanel.description': 'Ваша обратная связь - это движущая сила улучшения нашего продукта. Независимо от того, нашли ли вы ошибку или у вас есть блестящая идея для новой функции, дайте нам знать.',
  'feedback.contact.helpDoc.title': 'Документация помощи',
  'feedback.contact.helpDoc.desc': 'Просмотр FAQ и руководств пользователя',
  'feedback.contact.email.title': 'Поддержка по электронной почте',
  'feedback.contact.service.title': 'Онлайн-поддержка',
  'feedback.contact.service.hours': 'Рабочие дни 9:00 - 18:00',
  'feedback.type.suggestion.title': 'Предложение функции',
  'feedback.type.suggestion.desc': 'У меня есть новые идеи или предложения по улучшению',
  'feedback.type.bug.title': 'Отчет об ошибке',
  'feedback.type.bug.desc': 'Я столкнулся с ошибкой или исключением',
  'feedback.type.question.title': 'Запрос об использовании',
  'feedback.type.question.desc': 'Я не понимаю, как использовать функцию',
  'feedback.type.other.title': 'Другое',
  'feedback.type.other.desc': 'Другие типы обратной связи',
  'feedback.form.type.label': 'Тип обратной связи',
  'feedback.form.title.label': 'Краткое резюме',
  'feedback.form.title.placeholder': 'Опишите вашу проблему или предложение в одном предложении',
  'feedback.form.title.required': 'Пожалуйста, введите заголовок',
  'feedback.form.content.label': 'Подробное описание',
  'feedback.form.content.placeholder': 'Пожалуйста, опишите контекст, шаги воспроизведения или конкретные предложения...',
  'feedback.form.content.required': 'Пожалуйста, введите подробное содержание',
  'feedback.form.attachment.label': 'Вложения (Необязательно)',
  'feedback.upload.dragText': 'Нажмите или перетащите файлы сюда для загрузки',
  'feedback.upload.hint': 'Поддерживает форматы JPG, PNG, PDF и другие, размер одного файла не более 5MB',
  'feedback.upload.sizeLimit': 'Размер файла не может превышать 5MB',
  'feedback.form.priority.label': 'Приоритет',
  'feedback.priority.low.label': 'Низкий',
  'feedback.priority.low.desc': 'Не влияет на использование',
  'feedback.priority.medium.label': 'Средний',
  'feedback.priority.medium.desc': 'Влияет на пользовательский опыт',
  'feedback.priority.high.label': 'Высокий',
  'feedback.priority.high.desc': 'Серьезно препятствует использованию',
  'feedback.form.contact.label': 'Контактная информация (Необязательно)',
  'feedback.form.contact.placeholder': 'Электронная почта или номер телефона',
  'feedback.form.submit': 'Отправить отзыв',
  'feedback.submit.error': 'Отправка не удалась, пожалуйста, попробуйте позже',
  'feedback.success.title': 'Отзыв получен!',
  'feedback.success.description': 'Спасибо за ваш ценный отзыв. Наша команда продукта внимательно прочитает каждый отзыв. Если это отчет об ошибке, мы можем связаться с вами через предоставленную контактную информацию.',
  'feedback.success.back': 'Назад',
  'feedback.success.another': 'Отправить еще один',
  // Страница приглашений
  'invite.partnerProgram': 'Партнёрская программа',
  'invite.title.line1': 'Приглашайте друзей',
  'invite.title.line2': 'Создавайте безграничную ценность',
  'invite.reward.inviter': 'Получайте {amount} денежного вознаграждения за каждого приглашённого друга.',
  'invite.reward.invitee': 'Ваш друг получает {amount} приветственный бонус при регистрации.',
  'invite.step1.title': '1. Поделитесь ссылкой',
  'invite.step1.desc': 'Поделитесь вашей эксклюзивной ссылкой в соцсетях',
  'invite.step2.title': '2. Друг активируется',
  'invite.step2.desc': 'Друг завершает регистрацию и верификацию',
  'invite.step3.title': '3. Выводите заработок',
  'invite.step3.desc': 'Мгновенный заработок, вывод на баланс',
  'invite.exclusiveCode': 'ВАШ ЭКСКЛЮЗИВНЫЙ КОД',
  'invite.copyCode': 'Копировать код',
  'invite.viewQrcode': 'Показать QR-код',
  'invite.stats.totalInvites': 'Всего приглашений',
  'invite.stats.availableReward': 'Доступный баланс',
  'invite.stats.totalReward': 'Общий заработок',
  'invite.withdrawNow': 'Вывести сейчас',
  'invite.history.title': 'История приглашений',
  'invite.filter.all': 'Все',
  'invite.filter.active': 'Активные',
  'invite.filter.pending': 'Ожидающие',
  'invite.status.credited': 'Зачислено',
  'invite.status.pending': 'Ожидание',
  'invite.history.empty': 'Нет записей',
  'invite.withdraw.title': 'Вывод заработка',
  'invite.withdraw.cancel': 'Отмена',
  'invite.withdraw.confirm': 'Подтвердить вывод',
  'invite.withdraw.amount': 'Сумма вывода',
  'invite.withdraw.note': '* Сумма будет переведена напрямую на баланс вашего аккаунта.',
  'invite.withdraw.enterAmount': 'Пожалуйста, введите сумму вывода',
  'invite.withdraw.insufficientBalance': 'Недостаточный баланс',
  'invite.withdraw.success': '¥{amount} успешно выведено на баланс',
  'invite.qrcode.title': 'Сканируйте для присоединения',
  'invite.copyLink': 'Копировать ссылку',
  'invite.copy.success': 'Скопировано',
  // Раздел Hero главной страницы
  'home.hero.badge': 'ИИ-помощник · Спутник · Партнер',
  'home.hero.title': 'AIMATEX',
  'home.hero.subtitle': 'Ваш Одноклассник, Родственная Душа, Товарищ по Команде',
  'home.hero.description': 'AIMATEX — это ваш ИИ-помощник, партнер по обучению и творческий спутник. Мы предоставляем комплексные решения на основе ИИ, делая ИИ вашим лучшим партнером в работе, учебе и творчестве. Будь то обучение в классе, творческое сотрудничество или командная работа, AIMATEX — ваш надежный партнер.',
  'home.hero.cta.signup': 'Начать бесплатно',
  'home.hero.cta.login': 'Войти',
  'home.hero.cta.workspace': 'Перейти в рабочую область',
  // Раздел продуктов главной страницы
  'home.products.title': 'Наши Продукты',
  'home.products.subtitle': 'Исследуйте инновационные продукты ИИ от AIMATEX, каждый продукт — ваш лучший партнер в разных сценариях',
  'home.products.seedance2.name': 'Seedance2',
  'home.products.seedance2.description': 'Партнер по созданию видео из изображений с ИИ, преобразующий статические изображения в динамические видео, оживляя ваше творчество',
  'home.products.ai2obj.name': 'AI2Obj',
  'home.products.ai2obj.description': 'Платформа генерации и преобразования 3D-объектов на основе ИИ, ваш партнер по 3D-творчеству',
  'home.products.openrobotx.name': 'OpenRobotX',
  'home.products.openrobotx.description': 'Исследуйте глобальные компании гуманоидных роботов, сравнения параметров и отраслевую информацию, ваш партнер по исследованиям в робототехнике',
  'home.products.openclaw4j.name': 'OpenClaw4j',
  'home.products.openclaw4j.title': 'OpenClaw4j',
  'home.products.openclaw4j.description': 'Платформа автономных агентов — создавайте и развертывайте интеллектуальных агентов с OpenForgeX.',
  'home.products.openclaw4j.cta': 'Попробовать агента',
  'home.products.aimatexMusic.name': 'AIMATEX-MUSIC',
  'home.products.aimatexMusic.title': 'AIMATEX-MUSIC',
  'home.products.aimatexMusic.description': 'Личное облачное музыкальное пространство — поиск треков, совместные плейлисты, Now Playing и облачная библиотека',
  'home.products.aimatexMusic.cta': 'Открыть музыку',
  'home.music.eyebrow': 'Линейка AIMATEX',
  'home.music.title': 'AIMATEX-MUSIC',
  'home.music.subtitle': 'Личное облачное музыкальное пространство — искать, собирать и слушать вместе.',
  'home.music.feature.discover.title': 'Открытие',
  'home.music.feature.discover.desc': 'Ищите и импортируйте треки в облачную библиотеку.',
  'home.music.feature.playlist.title': 'Плейлисты',
  'home.music.feature.playlist.desc': 'Создавайте и делитесь совместными плейлистами.',
  'home.music.feature.nowPlaying.title': 'Сейчас играет',
  'home.music.feature.nowPlaying.desc': 'Синхронное прослушивание, лайки и история.',
  'home.music.feature.cloud.title': 'Облачная библиотека',
  'home.music.feature.cloud.desc': 'Качественное аудио в облаке.',
  'home.music.cta': 'Открыть AIMATEX-MUSIC',
'home.showcase.seedance2.eyebrow': 'Image to Video',
  'home.showcase.seedance2.title': 'Seedance2',
  'home.showcase.seedance2.subtitle': 'Turn still frames into cinematic motion with a next-gen creation engine.',
  'home.showcase.seedance2.f1.title': 'Image to Video',
  'home.showcase.seedance2.f1.desc': 'Upload a photo — AI invents light and motion.',
  'home.showcase.seedance2.f2.title': 'Cinema Quality',
  'home.showcase.seedance2.f2.desc': 'High-res output with stable, crisp detail.',
  'home.showcase.seedance2.f3.title': 'Smart Prompts',
  'home.showcase.seedance2.f3.desc': 'AI polishes rough ideas into film-ready prompts.',
  'home.showcase.seedance2.f4.title': 'Style Switch',
  'home.showcase.seedance2.f4.desc': 'Cyberpunk, oil paint, anime — one click.',
  'home.showcase.seedance2.cta': 'Enter Seedance2',
  'home.showcase.ai2obj.eyebrow': '3D Generation',
  'home.showcase.ai2obj.title': 'AI2Obj',
  'home.showcase.ai2obj.subtitle': 'An AI generation platform that turns ideas into usable digital assets.',
  'home.showcase.ai2obj.f1.title': 'Multimodal',
  'home.showcase.ai2obj.f1.desc': 'From text and images to 3D and content assets.',
  'home.showcase.ai2obj.f2.title': 'Object Convert',
  'home.showcase.ai2obj.f2.desc': 'Structure understanding and format conversion.',
  'home.showcase.ai2obj.f3.title': 'Creator Workflow',
  'home.showcase.ai2obj.f3.desc': 'Pipelines built for product and content teams.',
  'home.showcase.ai2obj.f4.title': 'Cloud Delivery',
  'home.showcase.ai2obj.f4.desc': 'Preview, export, and collaborate in the cloud.',
  'home.showcase.ai2obj.cta': 'Visit AI2Obj',
  'home.showcase.openrobotx.eyebrow': 'Robotics Intel',
  'home.showcase.openrobotx.title': 'OpenRobotX',
  'home.showcase.openrobotx.subtitle': 'Global humanoid robot companies, specs, and industry insights in one place.',
  'home.showcase.openrobotx.f1.title': 'World Map',
  'home.showcase.openrobotx.f1.desc': 'Major humanoid vendors and products covered.',
  'home.showcase.openrobotx.f2.title': 'Spec Compare',
  'home.showcase.openrobotx.f2.desc': 'Clear side-by-side capability and positioning.',
  'home.showcase.openrobotx.f3.title': 'Industry News',
  'home.showcase.openrobotx.f3.desc': 'Funding, launches, and tech movements tracked.',
  'home.showcase.openrobotx.f4.title': 'Research Partner',
  'home.showcase.openrobotx.f4.desc': 'Structured intel for selection and research.',
  'home.showcase.openrobotx.cta': 'Explore OpenRobotX',
  'home.showcase.openclaw4j.eyebrow': 'Autonomous Agents',
  'home.showcase.openclaw4j.title': 'OpenClaw4j',
  'home.showcase.openclaw4j.subtitle': 'Build and deploy intelligent agents with OpenForgeX — make agents run for real.',
  'home.showcase.openclaw4j.f1.title': 'Agent Orchestration',
  'home.showcase.openclaw4j.f1.desc': 'Multi-step planning and execution.',
  'home.showcase.openclaw4j.f2.title': 'Tool Calling',
  'home.showcase.openclaw4j.f2.desc': 'Connect APIs and business systems.',
  'home.showcase.openclaw4j.f3.title': 'Observable Runs',
  'home.showcase.openclaw4j.f3.desc': 'Transparent traces for debug and iteration.',
  'home.showcase.openclaw4j.f4.title': 'One-click Deploy',
  'home.showcase.openclaw4j.f4.desc': 'From prototype to live service fast.',
  'home.showcase.openclaw4j.cta': 'Try Agent',
  'home.products.learnMore': 'Узнать больше',
  // Раздел функций главной страницы
  'home.features.title': 'Универсальная творческая мастерская.',
  'home.features.subtitle': 'Больше, чем просто генерация видео, это всестороннее творческое расширение возможностей.',
  'home.features.aiPrompt.title': 'Не можете писать промпты? ИИ напишет за вас',
  'home.features.aiPrompt.description': 'Совсем нет идей? Позвольте ИИ написать за вас одним кликом. Просто введите несколько слов, ИИ автоматически отшлифует их в кинематографические описания, 10 секунд на генерацию. Хотите изменить стиль? Нажмите еще раз, мгновенно превратите в киберпанк/масляную живопись/аниме.',
  'home.features.demo.userInput': 'кошка',
  'home.features.demo.aiResult': 'Элегантная персидская кошка с мягкой пушистой белой длинной шерстью и янтарными глазами, сидящая на залитом солнцем подоконнике. Фон представляет светло-голубое небо и развевающиеся белые занавески. 4K ультра HD, кинематографическое освещение, глубина резкости, профессиональная фотография.',
  'home.features.demo.buttonText': 'Генерация ИИ',
  'home.features.demo.buttonLoading': 'Генерация',
  'home.features.demo.thinkingText': 'ИИ создает✨',
  'home.features.quality.title': 'Кинематографическое качество',
  'home.features.quality.description': 'Нативная поддержка вывода в разрешении 4K, каждый кадр тщательно проработан.',
  'home.features.imageToVideo.title': 'Изображение в видео',
  'home.features.imageToVideo.description': 'Загрузите статическое изображение, ИИ поймет освещение и физику в сцене, автоматически сгенерирует последующую динамику, оживляя фотографии.',
  'home.features.multimodal.title': 'Мультимодальная экосистема',
  'home.features.multimodal.description': 'Не только поддерживает Stable Diffusion текст-в-изображение, но также интегрирует перенос стиля Midjourney и синтез аудио ElevenLabs. Выполните все творения в одном рабочем процессе.',
  
  // Раздел сообщества на главной странице
  'home.community.title': 'Исследуйте творческие сообщества ИИ',
  'home.community.subtitle': 'Присоединяйтесь к миллионам создателей, делитесь своими шедеврами ИИ и получайте вдохновение и отзывы',
  'home.community.hot': 'Популярное',
  'home.community.explore': 'Исследовать сообщество',
  'home.community.stats.works': 'Работы',
  'home.community.stats.creators': 'Создатели',
  'home.community.stats.views': 'Просмотры',
  'home.community.image.title': 'Сообщество изображений ИИ',
  'home.community.image.description': 'Откройте для себя и поделитесь потрясающими изображениями, созданными ИИ, от фотореализма до художественных работ, от иллюстраций до фотографии',
  'home.community.video.title': 'Сообщество видео ИИ',
  'home.community.video.description': 'Исследуйте удивительные видео, созданные ИИ, изучайте творческие техники и обменивайтесь опытом с мировыми видеокреаторами',
  'home.community.music.title': 'Сообщество музыки ИИ',
  'home.community.music.description': 'Слушайте прекрасные мелодии, сочиненные ИИ, делитесь своими музыкальными произведениями и находите единомышленников-меломанов',
  'home.community.3d.title': 'Сообщество 3D-моделей ИИ',
  'home.community.3d.description': 'Исследуйте мир 3D-моделей, созданных ИИ, от архитектуры до персонажей, от игр до промышленного дизайна',
  'home.community.voice.title': 'Сообщество голоса ИИ',
  'home.community.voice.description': 'Испытайте реалистичный синтез голоса ИИ, дубляж, аудиокниги, клонирование голоса и оживите свои творения',
  'home.community.text.title': 'Сообщество текста ИИ',
  'home.community.text.description': 'Делитесь отличными текстами, созданными ИИ, романами, стихами, сценариями, копирайтингом и вдохновляйте свое литературное творчество',
  
  // Страница выставления счетов
  'billing.page.title': 'Финансовый центр',
  'billing.page.description': 'Управляйте транзакциями и деталями выставления счетов',
  'billing.button.refresh': 'Обновить',
  'billing.button.recharge': 'Пополнить',
  'billing.button.reset': 'Сбросить',
  'billing.button.apply': 'Применить фильтры',
  'billing.balance.cny': 'Баланс CNY',
  'billing.balance.usdt': 'Баланс USDT',
  'billing.balance.usd': 'Баланс USD',
  'billing.balance.token': 'Баланс токенов',
  'billing.balance.frozen': 'Заморожено',
  'billing.type.frozen': 'Средства заморожены',
  'billing.type.aiModelFee': 'Плата за модель ИИ',
  'billing.type.recharge': 'Пополнение',
  'billing.type.refund': 'Возврат',
  'billing.type.reward': 'Награда',
  'billing.type.all': 'Все типы',
  'billing.coin.all': 'Все валюты',
  'billing.coin.usdt': 'USDT',
  'billing.coin.cny': 'CNY',
  'billing.coin.usd': 'USD',
  'billing.coin.token': 'TOKEN',
  'billing.table.type': 'Тип',
  'billing.table.coinType': 'Валюта',
  'billing.table.time': 'Время',
  'billing.table.amount': 'Сумма',
  'billing.table.remark': 'Примечание',
  'billing.table.balance': 'Баланс',
  'billing.table.empty': 'Нет записей',
  'billing.filter.title': 'Параметры фильтра',
  'billing.filter.button': 'Фильтр и дата',
  'billing.filter.changeType': 'Тип транзакции',
  'billing.filter.coinType': 'Тип валюты',
  'billing.filter.remark': 'Поиск примечаний',
  'billing.filter.remarkPlaceholder': 'Введите ключевые слова',
  'billing.filter.remarkSearch': 'Поиск примечаний',
  'billing.filter.dateQuick': 'Быстрая дата',
  'billing.filter.dateCustom': 'Пользовательская дата',
  'billing.filter.dateTo': 'до',
  'billing.filter.days7': 'Последние 7 дней',
  'billing.filter.days30': 'Последние 30 дней',
  'billing.filter.days90': 'Последние 3 месяца',
  'billing.placeholder.changeType': 'Тип изменения',
  'billing.placeholder.coinType': 'Валюта',
  'billing.placeholder.remark': 'Поиск примечаний',
  'billing.message.fetchBalanceError': 'Не удалось получить баланс',
  'billing.message.fetchRecordsError': 'Не удалось получить записи выставления счетов',
  'billing.message.tryAgain': 'Не удалось получить записи выставления счетов, повторите попытку позже',
  
  // Страница пополнения
  'recharge.page.title': 'Пополнение счета',
  'recharge.page.backLink': 'Вернуться к выставлению счетов',
  'recharge.balance.title': 'Баланс счета',
  'recharge.balance.refresh': 'Обновить',
  'recharge.section.coinType': 'Валюта пополнения',
  'recharge.section.paymentMethod': 'Способ оплаты',
  'recharge.section.amount': 'Сумма пополнения',
  'recharge.order.title': 'Детали заказа',
  'recharge.order.type': 'Тип пополнения',
  'recharge.order.typeValue': 'Пополнение баланса счета',
  'recharge.order.account': 'Счет',
  'recharge.order.accountLoading': 'Загрузка...',
  'recharge.order.paymentMethod': 'Способ оплаты',
  'recharge.order.paymentMethodPlease': 'Пожалуйста, выберите',
  'recharge.order.total': 'Общая сумма',
  'recharge.button.pay': 'Оплатить сейчас',
  'recharge.button.customize': 'Пользовательская сумма',
  'recharge.placeholder.customAmount': 'Введите пользовательскую сумму',
  'recharge.security.ssl': 'Зашифрованная передача SSL, безопасная оплата',
  'recharge.security.agreement': 'Нажимая "Оплатить", вы соглашаетесь с',
  'recharge.security.agreementLink': 'Соглашение об услуге пополнения',
  'recharge.empty.noCurrency': 'Нет поддерживаемых валют',
  'recharge.empty.noPaymentMethod': 'Нет способа оплаты для {currency}',
  'recharge.empty.pleaseSelectCurrency': 'Пожалуйста, сначала выберите валюту',
  'recharge.empty.pleaseSelectPayment': 'Пожалуйста, сначала выберите способ оплаты',
  'recharge.empty.noProducts': 'Нет доступных продуктов',
  'recharge.empty.noPresets': 'Нет предустановленных сумм для {currency}',
  'recharge.message.invalidAmount': 'Пожалуйста, введите действительную сумму',
  'recharge.message.selectPaymentMethod': 'Пожалуйста, выберите способ оплаты',
  'recharge.message.selectAmount': 'Пожалуйста, выберите сумму пополнения',
  'recharge.message.fetchBalanceError': 'Не удалось получить баланс, повторите попытку позже',
  'recharge.message.fetchUserInfoError': 'Не удалось получить информацию о пользователе',
  'recharge.message.fetchCurrenciesError': 'Не удалось получить валюты, повторите попытку позже',
  'recharge.message.fetchPaymentMethodsError': 'Не удалось получить способы оплаты, повторите попытку позже',
  'recharge.message.fetchCreemProductsError': 'Не удалось получить продукты Creem, повторите попытку позже',
  'recharge.message.fetchCreemProductsWarning': 'Не удалось получить продукты Creem',
  'recharge.message.orderCreated': 'Заказ успешно создан',
  'recharge.message.orderCreateFailed': 'Не удалось создать заказ на пополнение',
  'recharge.message.paymentProcessing': 'Открытие страницы оплаты, завершите оплату...',
  'recharge.message.popupBlocked': 'Не удается открыть окно оплаты, проверьте настройки всплывающих окон браузера',
  'recharge.message.paymentUrlError': 'Не удалось получить URL оплаты',
  'recharge.message.checkoutSessionError': 'Не удалось создать сеанс оплаты',
  'recharge.message.paymentError': 'Ошибка обработки платежа, повторите попытку позже',
  'recharge.message.redirecting': 'Перенаправление на страницу оплаты, завершите оплату...',
  'recharge.message.paymentUrlFailed': 'URL оплаты недоступен',
  'recharge.message.paymentSuccess': 'Платеж успешен! Баланс обновлен',
  'recharge.message.orderCancelled': 'Заказ отменен',
  'recharge.message.paymentFailed': 'Платеж не прошел',
  'recharge.message.orderExpired': 'Истек',
  'recharge.message.queryOrderError': 'Не удалось запросить статус заказа',
  'recharge.message.rechargeError': 'Ошибка запроса на пополнение, повторите попытку позже',

  // Страница заказов
  'orders.title': 'История заказов',
  'orders.subtitle': 'Просмотр всех записей о заказах пополнения и их статусов',
  'orders.refresh': 'Обновить',
  'orders.goToRecharge': 'Пополнить',

  // Статистические карточки
  'orders.stats.totalOrders': 'Всего заказов',
  'orders.stats.pending': 'В ожидании',
  'orders.stats.paid': 'Оплачено',
  'orders.stats.totalAmount': 'Всего пополнено',

  // Столбцы таблицы
  'orders.table.orderNo': '№ заказа',
  'orders.table.createTime': 'Создан',
  'orders.table.amount': 'Сумма',
  'orders.table.paymentMethod': 'Способ оплаты',
  'orders.table.status': 'Статус',
  'orders.table.action': 'Действие',
  'orders.table.view': 'Просмотр',
  'orders.table.cancel': 'Отменить',
  'orders.table.empty': 'Нет записей о заказах',

  // Статус заказа
  'orders.status.pending': 'В ожидании',
  'orders.status.paid': 'Оплачено',
  'orders.status.success': 'Завершено',
  'orders.status.cancelled': 'Отменено',
  'orders.status.failed': 'Не удалось',
  'orders.status.expired': 'Истек срок',
  'orders.status.all': 'Все статусы',

  // Способы оплаты
  'orders.payment.alipay': 'Alipay',
  'orders.payment.wechat': 'WeChat Pay',
  'orders.payment.bank': 'Банковская карта',
  'orders.payment.usdt': 'USDT',
  'orders.payment.creem': 'Creem',
  'orders.payment.all': 'Все способы',

  // Валюта
  'orders.coin.all': 'Все валюты',

  // Фильтры
  'orders.filter.title': 'Параметры фильтра',
  'orders.filter.button': 'Фильтровать заказы',
  'orders.filter.reset': 'Сбросить',
  'orders.filter.apply': 'Применить',
  'orders.filter.orderStatus': 'Статус заказа',
  'orders.filter.paymentMethod': 'Способ оплаты',
  'orders.filter.coinType': 'Тип валюты',
  'orders.filter.orderNoSearch': 'Поиск по № заказа',
  'orders.filter.quickDate': 'Быстрая дата',
  'orders.filter.customDate': 'Пользовательская дата',
  'orders.filter.dateTo': 'до',
  'orders.filter.last7Days': 'Последние 7 дней',
  'orders.filter.last30Days': 'Последние 30 дней',
  'orders.filter.last3Months': 'Последние 3 месяца',

  // Поиск и ввод
  'orders.search.placeholder': 'Поиск номера заказа',
  'orders.input.orderNo': 'Введите номер заказа',
  'orders.select.orderStatus': 'Статус заказа',
  'orders.select.paymentMethod': 'Способ оплаты',
  'orders.select.coinType': 'Валюта',

  // Сообщения
  'orders.message.fetchError': 'Не удалось получить заказы',
  'orders.message.fetchErrorRetry': 'Не удалось получить заказы, повторите попытку позже',
  'orders.message.statsError': 'Не удалось получить статистику',
  'orders.message.cancelSuccess': 'Заказ отменен',
  'orders.message.cancelError': 'Не удалось отменить заказ',
  'orders.message.cancelErrorRetry': 'Не удалось отменить заказ, повторите попытку позже',
  'orders.message.viewOrder': '№ заказа: {orderNo}',

  // Диалог подтверждения
  'orders.confirm.cancel': 'Вы уверены, что хотите отменить этот заказ?',
  'orders.confirm.ok': 'ОК',
  'orders.confirm.cancelButton': 'Отмена',

  // Страница Вакансии
  'joinUs.seo.title': 'Присоединиться к PROTX - Стремление к совершенству',
  'joinUs.seo.description': 'Присоединяйтесь к команде PROTX и стремитесь к идеальному пользовательскому опыту и дизайну продукта вместе с нами',
  'joinUs.hero.eyebrow': 'JOIN PROTX',
  'joinUs.hero.title': 'Стремление к совершенству',
  'joinUs.hero.title2': 'Определяя будущее через дизайн',
  'joinUs.hero.subtitle': 'PROTX — это команда, посвящённая созданию идеального пользовательского опыта и дизайна продукта. Мы верим, что каждый пиксель имеет значение, каждое взаимодействие заслуживает тщательной проработки. Если вы разделяете наше неустанное стремление к совершенству, присоединяйтесь к нам.',
  'joinUs.hero.cta': 'Смотреть вакансии',
  'joinUs.hero.video': 'Смотреть нашу историю',
  
  'joinUs.values.eyebrow': 'НАШИ ЦЕННОСТИ',
  'joinUs.values.title': 'Наши основные ценности',
  'joinUs.values.subtitle': 'Эти основные ценности определяют, кто мы и как мы работаем вместе',
  'joinUs.values.innovation.title': 'Ориентация на инновации',
  'joinUs.values.innovation.desc': 'Мы верим, что инновации — это сила, которая меняет мир, поощряя каждую прорывную идею.',
  'joinUs.values.collaboration.title': 'Совместный успех',
  'joinUs.values.collaboration.desc': 'Межкомандное сотрудничество для создания выдающихся результатов вместе.',
  'joinUs.values.excellence.title': 'Стремление к совершенству',
  'joinUs.values.excellence.desc': 'Постоянно расширяя границы для идеального опыта.',
  'joinUs.values.passion.title': 'Страсть и фокус',
  'joinUs.values.passion.desc': 'Любовь к технологиям, преданность продукту.',
  'joinUs.values.impact.title': 'Создание влияния',
  'joinUs.values.impact.desc': 'Раскрытие творческого потенциала каждого с помощью ИИ-технологий.',
  
  'joinUs.positions.eyebrow': 'ОТКРЫТЫЕ ВАКАНСИИ',
  'joinUs.positions.title': 'Открытые вакансии',
  'joinUs.positions.subtitle': 'Найдите роль, которая вам подходит, и начните новый карьерный путь',
  'joinUs.category.engineering': 'Инженерия',
  'joinUs.category.product': 'Продукт и Дизайн',
  'joinUs.category.operations': 'Операции и Маркетинг',
  'joinUs.position.seniorFrontend': 'Старший Frontend-разработчик',
  'joinUs.position.backendEngineer': 'Backend-разработчик',
  'joinUs.position.mlEngineer': 'Инженер ИИ/ML',
  'joinUs.position.productManager': 'Продакт-менеджер',
  'joinUs.position.uxDesigner': 'UX-дизайнер',
  'joinUs.position.communityManager': 'Менеджер сообщества',
  'joinUs.position.contentCreator': 'Создатель контента',
  'joinUs.location.remote': 'Удаленно',
  'joinUs.location.beijing': 'Пекин',
  'joinUs.location.shanghai': 'Шанхай',
  'joinUs.location.shenzhen': 'Шэньчжэнь',
  'joinUs.type.fulltime': 'Полная занятость',
  'joinUs.type.parttime': 'Частичная занятость',
  
  'joinUs.benefits.eyebrow': 'ПРЕИМУЩЕСТВА',
  'joinUs.benefits.title': 'Что мы предлагаем',
  'joinUs.benefits.subtitle': 'Присоединяйтесь к нам и получите комплексные льготы и поддержку',
  'joinUs.benefit.flexible.title': 'Гибкая работа',
  'joinUs.benefit.flexible.desc': 'Гибкий график и возможность удаленной работы',
  'joinUs.benefit.equity.title': 'Опционы',
  'joinUs.benefit.equity.desc': 'Растите вместе с компанией и разделяйте наш успех',
  'joinUs.benefit.health.title': 'Медицинское страхование',
  'joinUs.benefit.health.desc': 'Комплексное медицинское страхование и программы здоровья',
  'joinUs.benefit.growth.title': 'Карьерный рост',
  'joinUs.benefit.growth.desc': 'Постоянные возможности обучения и развития',
  
  'joinUs.cta.title': 'Готовы начать?',
  'joinUs.cta.subtitle': 'Если вас вдохновляет наша миссия, мы ждем вашу заявку',
  'joinUs.cta.button': 'Подать заявку',
  
  'joinUs.modal.title': 'Заявка на вакансию',
  'joinUs.apply.success': 'Заявка отправлена! Мы свяжемся с вами в ближайшее время.',
  'joinUs.form.name': 'Имя',
  'joinUs.form.name.required': 'Пожалуйста, введите ваше имя',
  'joinUs.form.name.placeholder': 'Введите ваше имя',
  'joinUs.form.email': 'Email',
  'joinUs.form.email.required': 'Пожалуйста, введите ваш email',
  'joinUs.form.email.invalid': 'Пожалуйста, введите действительный email',
  'joinUs.form.email.placeholder': 'Введите ваш email',
  'joinUs.form.phone': 'Телефон',
  'joinUs.form.phone.placeholder': 'Введите ваш номер телефона',
  'joinUs.form.experience': 'Опыт работы',
  'joinUs.form.experience.placeholder': 'Выберите ваш уровень опыта',
  'joinUs.form.experience.0-2': '0-2 года',
  'joinUs.form.experience.3-5': '3-5 лет',
  'joinUs.form.experience.5-10': '5-10 лет',
  'joinUs.form.experience.10+': '10+ лет',
  'joinUs.form.resume': 'Резюме',
  'joinUs.form.resume.hint': 'Нажмите или перетащите файл для загрузки',
  'joinUs.form.resume.format': 'Поддерживаются форматы PDF, DOC, DOCX',
  'joinUs.form.message': 'Сопроводительное письмо',
  'joinUs.form.message.placeholder': 'Расскажите о себе и почему хотите присоединиться к нам',
  'joinUs.form.submit': 'Отправить заявку',
  'joinUs.form.loginTip': 'Войдите перед отправкой, чтобы отслеживать свою заявку',
  'joinUs.form.goLogin': 'Войти',
  'joinUs.form.resume.sizeLimit': 'Размер файла не может превышать 10 МБ',
  
  // Мои заявки
  'joinUs.myApplications.eyebrow': 'МОИ ЗАЯВКИ',
  'joinUs.myApplications.title': 'История заявок',
  'joinUs.myApplications.empty': 'Пока нет заявок. Отправьте резюме сейчас!',
  'joinUs.myApplications.viewDetail': 'Подробнее',
  'joinUs.myApplications.detailTitle': 'Детали заявки',
  'joinUs.status.pending': 'Ожидает',
  'joinUs.status.reviewing': 'На рассмотрении',
  'joinUs.status.interview': 'Собеседование',
  'joinUs.status.accepted': 'Принято',
  'joinUs.status.rejected': 'Отклонено',
  'joinUs.detail.basicInfo': 'Основная информация',
  'joinUs.detail.positionInfo': 'Информация о вакансии',
  'joinUs.detail.position': 'Вакансия',
  'joinUs.detail.category': 'Категория',
  'joinUs.detail.location': 'Местоположение',
  'joinUs.detail.applyTime': 'Дата подачи',
  'joinUs.detail.downloadResume': 'Скачать резюме',
  'joinUs.detail.status': 'Статус заявки',

  // Страница About
  'about.hero.title1': 'Открытое ядро.',
  'about.hero.title2': 'Бесконечные возможности.',
  'about.hero.subtitle1': 'На основе',
  'about.hero.subtitle2': 'и',
  'about.hero.subtitle3': 'экосистемы.',
  'about.hero.description': 'Мы упаковываем передовой технологический стек генеративного ИИ 2025 года в идеальный интерактивный опыт.',
  'about.tech.poweredBy': 'Работает на',
  'about.philosophy.title1': 'Больше чем генерация.',
  'about.philosophy.title2': 'Это полный процесс',
  'about.philosophy.title3': 'двигатель творчества.',
  'about.philosophy.description': 'От точного контроля в текст-в-изображение до физической симуляции в генерации видео — мы стремимся к пределам технологий.',
  'about.bento.comfy.title': 'Точный контроль на уровне узлов.',
  'about.bento.comfy.description': 'Построен на архитектуре узлов ComfyUI с поддержкой управления позой ControlNet и переноса стиля IP-Adapter. Мы инкапсулируем сложную логику узлов в интуитивные ползунки, делая каждую генерацию именно такой, как вы представляете.',
  'about.bento.opensource.title': 'Принятие открытого кода.',
  'about.bento.opensource.description': 'На основе Stable Diffusion 3.5 & XL Turbo. Не только молниеносная генерация, но и массивная поддержка моделей LoRA от сообщества.',
  'about.bento.video.title': 'Видео архитектура DiT.',
  'about.bento.video.description': 'Внедрение Diffusion Transformer (DiT) с механизмом пространственно-временного внимания, достигающего симуляции физического мира уровня SORA.',
  'about.bento.audio.title': 'Аудио-визуальная синхронизация, пробуждение чувств.',
  'about.bento.audio.description': 'Больше чем визуальное. Интегрировано с новейшими моделями генерации аудио, поддерживая Text-to-Audio и автоматическое выравнивание видео. От зрения к слуху — создание полного иммерсивного опыта.',
  'about.techSection.title': 'Техническая архитектура.',
  'about.techSection.description': 'Погрузитесь в ядро движка, питающего ProductX.',
  'about.techCard.sd.title': 'Основа генеративного искусства.',
  'about.techCard.sd.description': 'Мы глубоко интегрируем новейшие модели генерации Stable Diffusion. Благодаря пользовательскому VAE и оптимизированным сэмплерам мы достигаем 300% более быстрой генерации при сохранении изысканного качества изображения.',
  'about.techCard.spec.baseModel': 'Базовая модель',
  'about.techCard.spec.resolution': 'Разрешение',
  'about.techCard.spec.resolution.value': 'До 4K Upscaling',
  'about.techCard.spec.control': 'Управление',
  'about.techCard.spec.speed': 'Скорость',
  'about.techCard.spec.speed.value': '< 1с (Турбо режим)',
  'about.techCard.video.title': 'Видео физический движок нового поколения.',
  'about.techCard.video.description': 'Отказ от традиционной логики 2D-анимации, внедрение новейшей архитектуры DiT (Diffusion Transformer) 2025 года. Модель понимает освещение, гравитацию и физику движения, генерируя не просто видео, а физически точные динамические миры.',
  'about.techCard.spec.architecture': 'Архитектура',
  'about.techCard.spec.frameRate': 'Частота кадров',
  'about.techCard.spec.frameRate.value': 'Интерполяция 24 / 60 FPS',
  'about.techCard.spec.consistency': 'Согласованность',
  'about.techCard.spec.consistency.value': 'Высокая временная стабильность',
  'about.techCard.spec.length': 'Длительность',
  'about.techCard.spec.length.value': 'Бесконечное расширение цикла',
  'about.techCard.img2img.title': 'Изображение-в-изображение и перенос стиля.',
  'about.techCard.img2img.description': 'Используя технологии IP-Adapter и T2I-Adapter, мы достигаем zero-shot переноса стиля. Загрузите эталонное изображение, чтобы мгновенно воспроизвести его композицию, освещение и художественный стиль, раскрывая бесконечные творческие возможности.',
  'about.techCard.spec.technology': 'Технология',
  'about.techCard.spec.precision': 'Точность',
  'about.techCard.spec.precision.value': 'Пиксельно-точный инпейнтинг',
  'about.cta.title': 'Готовы испытать будущее?',
  'about.cta.description': 'Присоединяйтесь к рядам профессиональных создателей и раскройте предельный потенциал ИИ.',
  'about.cta.button.start': 'Начать',
  'about.cta.button.docs': 'Читать документацию',
  
  // Community
  'community.explore.title': 'Исследовать сообщества',
  'community.explore.subtitle': 'Откройте для себя вдохновение, ремикшируйте рабочие процессы и общайтесь с тысячами создателей ИИ.',
  'community.posts': '{count} публикаций',
  'community.empty': 'Нет каналов сообщества',
  'community.loadFailed': 'Ошибка загрузки',
  'community.noPosts': 'Пока нет публикаций',
  'community.challenge.loadFailed': 'Ошибка загрузки данных челленджа',
  
  'common.loadFailed': 'Ошибка загрузки',
  'common.operationFailed': 'Операция не выполнена',
  'common.error': 'Операция не выполнена',
  'common.publish': 'Опубликовать',
  'common.back': 'Назад',
  'common.backToCommunity': 'Вернуться в сообщество',
  'common.copy': 'Копировать',
  'common.copied': 'Скопировано',
  'common.follow': 'Подписаться',
  'common.processing': 'Обработка...',
  'common.viewCount': '{count} просмотров',
  'common.loadMore': 'Загрузить еще',
  'common.search': 'Поиск...',
  'common.notFound': 'Не найдено',
  'common.description': 'Описание',
  
  'user.followSuccess': 'Успешно подписан',
  'user.unfollowSuccess': 'Успешно отписан',
  'user.following': 'Подписан',
  'user.mutual_follow': 'Взаимно',
  
  'post.untitled': 'Безымянное творение',
  'post.prompt': 'Промпт',
  'post.negativePrompt': 'Негативный промпт',
  'post.details': 'Детали',
  'post.model': 'Модель',
  'post.resolution': 'Разрешение',
  'post.steps': 'Шаги',
  'post.cfgScale': 'Шкала руководства',
  'post.remix': 'Ремикс / Попробовать это',
  
  'challenge.status.upcoming': 'Скоро',
  'challenge.status.live': 'В процессе',
  'challenge.status.voting': 'Голосование',
  'challenge.status.ended': 'Завершен',
  'challenge.status.unknown': 'Неизвестно',
  'challenge.allChallenges': 'Все челленджи',
  'challenge.entriesCount': '{count} работ',
  'challenge.tab.submissions': 'Работы',
  'challenge.tab.rules': 'Правила и информация',
  'challenge.requirements': 'Требования',
  'challenge.req.original': 'Только оригинальные работы.',
  'challenge.req.model': 'Должна использоваться модель: {model}',
  'challenge.req.tags': 'Должны быть включены теги:',
  'challenge.req.resolution': 'Разрешение должно быть не менее 1024x1024.',
  'challenge.req.nsfw': 'Контент NSFW запрещен.',
  'challenge.timeRemaining': 'Осталось времени',
  'challenge.startsIn': 'До начала',
  'challenge.notStarted': 'Челлендж еще не начался',
  'challenge.closed': 'Челлендж закрыт',
  'challenge.submitEntry': 'Отправить работу',
  'challenge.viewWinners': 'Посмотреть победителей',
  'challenge.readRulesTip': 'Прочитайте правила перед отправкой',
  'challenge.prizePool': 'Призовой фонд',
  'challenge.totalValue': 'Общая стоимость',
  'challenge.rank.1st': '1-е место',
  'challenge.rank.2nd': '2-е место',
  'challenge.rank.3rd': '3-е место',
  'challenge.share': 'Поделиться челленджем',
  'challenge.noEntries': 'Пока нет работ. Станьте первым!',
  'challenge.noChallenges': 'Челленджи не найдены',
  // MediaTools
  'mediaTools.tab.imageCompress': 'Сжатие изображений',
  'mediaTools.tab.videoCompress': 'Сжатие видео',
  'mediaTools.tab.audioCompress': 'Сжатие аудио',
  'mediaTools.tab.formatConvert': 'Конвертация формата',
  // ImageCompress
  'imageCompress.title': 'Профессиональный инструмент сжатия изображений',
  'imageCompress.subtitle': 'Умное сжатие, профессиональное качество',
  'imageCompress.upload': 'Загрузить изображения',
  'imageCompress.addImages': 'Добавить изображения',
  'imageCompress.uploadToStart': 'Загрузите изображения для начала сжатия',
  'imageCompress.settings': 'Настройки',
  'imageCompress.clearAll': 'Очистить все',
  'imageCompress.totalSavings': 'Сэкономлено места',
  'imageCompress.totalSize': 'Общий размер',
  'imageCompress.quality': 'Качество',
  'imageCompress.resize': 'Изменить размер',
  'imageCompress.scalePercent': 'Масштаб %',
  'imageCompress.customPx': 'Пользовательский px',
  'imageCompress.presetSize': 'Предустановленный размер',
  'imageCompress.width': 'Ширина',
  'imageCompress.height': 'Высота',
  'imageCompress.format': 'Формат',
  'imageCompress.format.auto': 'Авто (оригинал)',
  'imageCompress.format.jpeg': 'JPEG (фото)',
  'imageCompress.format.png': 'PNG (без потерь)',
  'imageCompress.format.webp': 'WebP (лучший)',
  'imageCompress.pngLossless': 'PNG без потерь. Ползунок качества скрыт.',
  'imageCompress.cacheSettings': 'Настройки кэша',
  'imageCompress.cacheTooltip': 'При включении загруженные изображения будут сохранены в кэше браузера и восстановлены после обновления страницы.',
  'imageCompress.saveToCache': 'Сохранить изображения в кэше браузера',
  'imageCompress.batchProcessing': 'Пакетная обработка',
  'imageCompress.batchTooltip': 'При включении сжатие будет применено ко всем {count} изображениям с текущими настройками.',
  'imageCompress.applyToAll': 'Применить настройки ко всем изображениям ({count})',
  'imageCompress.compress': 'Применить и сжать',
  'imageCompress.compressAll': 'Применить и сжать все ({count})',
  'imageCompress.compressing': 'Сжатие...',
  'imageCompress.compressAllProgress': 'Сжатие {count} изображений...',
  'imageCompress.download': 'Скачать изображение',
  'imageCompress.downloadAll': 'Скачать все ({count})',
  'imageCompress.downloadAllCheckbox': 'Скачать все {count} изображений',
  'imageCompress.original': 'Оригинал',
  'imageCompress.compressed': 'Сжато',
  // Messages
  'imageCompress.message.compressed': 'Сжатие успешно!',
  'imageCompress.message.larger': 'Выходной файл больше. Попробуйте уменьшить качество.',
  'imageCompress.message.failed': 'Сжатие не удалось',
  'imageCompress.message.batchSuccess': 'Успешно сжато {success} изображений{failed}',
  'imageCompress.message.batchFailed': 'Все сжатия не удались',
  'imageCompress.message.noImagesToDownload': 'Нет сжатых изображений для скачивания',
  'imageCompress.message.downloading': 'Скачивание {count} изображений...',
  // Preset sizes
  'imageCompress.preset.instagramPost': 'Пост Instagram (1:1)',
  'imageCompress.preset.square': 'Квадрат (1:1)',
  'imageCompress.preset.facebookCover': 'Обложка Facebook (16:9)',
  'imageCompress.preset.twitterHeader': 'Заголовок Twitter (3:1)',
  'imageCompress.preset.youtubeThumbnail': 'Миниатюра YouTube (16:9)',
  'imageCompress.preset.facebookPost': 'Пост Facebook (1.91:1)',
  'imageCompress.preset.instagramStory': 'История Instagram (9:16)',
  'imageCompress.preset.tiktok': 'TikTok (9:16)',
  'imageCompress.preset.4kUHD': '4K UHD (16:9)',
  'imageCompress.preset.2kQHD': '2K QHD (16:9)',
  'imageCompress.preset.fullHD': 'Full HD (16:9)',
  'imageCompress.preset.hd': 'HD (16:9)',
  'imageCompress.preset.landscape16:9': 'Пейзаж 16:9',
  'imageCompress.preset.classic4:3': 'Классический 4:3',
  'imageCompress.preset.photo3:2': 'Фото 3:2',
  'imageCompress.preset.ultrawide21:9': 'Ультраширокий 21:9',
  'imageCompress.preset.a4Portrait': 'A4 Портрет (8.27×11.69")',
  'imageCompress.preset.a4Landscape': 'A4 Пейзаж (11.69×8.27")',
  'imageCompress.preset.letterPortrait': 'Letter Портрет (8.5×11")',
  // AudioCompress
  'audioCompress.title': 'Профессиональный инструмент сжатия аудио',
  'audioCompress.subtitle': 'Сжатие в браузере, конфиденциальность защищена',
  'audioCompress.upload': 'Загрузить аудио',
  'audioCompress.uploadNew': 'Нажмите, чтобы загрузить новое аудио',
  'audioCompress.uploadToStart': 'Загрузите аудио для начала сжатия',
  'audioCompress.settings': 'Настройки',
  'audioCompress.clearAll': 'Очистить все',
  'audioCompress.totalSavings': 'Сэкономлено места',
  'audioCompress.totalSize': 'Общий размер',
  'audioCompress.audioInfo': 'Информация об аудио',
  'audioCompress.quality': 'Качество',
  'audioCompress.bitrate': 'Битрейт',
  'audioCompress.bitrate.320': '320 кбит/с (Максимальное качество)',
  'audioCompress.bitrate.256': '256 кбит/с (Высокое качество)',
  'audioCompress.bitrate.192': '192 кбит/с (Стандартное качество)',
  'audioCompress.bitrate.128': '128 кбит/с (Среднее качество)',
  'audioCompress.bitrate.96': '96 кбит/с (Низкое качество)',
  'audioCompress.bitrate.64': '64 кбит/с (Минимальное качество)',
  'audioCompress.format': 'Формат',
  'audioCompress.format.mp3': 'MP3 (Рекомендуется)',
  'audioCompress.format.ogg': 'OGG',
  'audioCompress.format.aac': 'AAC',
  'audioCompress.format.wav': 'WAV',
  'audioCompress.sampleRate': 'Частота дискретизации',
  'audioCompress.sampleRate.48000': '48000 Гц',
  'audioCompress.sampleRate.44100': '44100 Гц (Качество CD)',
  'audioCompress.sampleRate.32000': '32000 Гц',
  'audioCompress.sampleRate.22050': '22050 Гц',
  'audioCompress.sampleRate.16000': '16000 Гц',
  'audioCompress.compress': 'Начать сжатие',
  'audioCompress.compressing': 'Сжатие...',
  'audioCompress.download': 'Скачать аудио',
  // AudioCompress Messages
  'audioCompress.message.compressed': 'Сжатие выполнено успешно!',
  'audioCompress.message.failed': 'Сжатие не удалось, попробуйте снова',
  'audioCompress.message.invalidFile': 'Пожалуйста, выберите аудиофайл!',
  'audioCompress.message.loadError': 'Не удалось загрузить аудиофайл',

  // Settings
  'settings.title': 'Системные настройки',
  'settings.description': 'Настройте платформу генерации ИИ',
  'settings.notifications.title': 'Уведомления',
  'settings.notifications.description': 'Управление уведомлениями',
  'settings.notifications.email': 'Email-уведомления',
  'settings.notifications.emailDesc': 'Получать важные обновления и уведомления о задачах',
  'settings.notifications.push': 'Push-уведомления',
  'settings.notifications.pushDesc': 'Получать push в реальном времени',
  'settings.notifications.sound': 'Звуковые уведомления',
  'settings.notifications.soundDesc': 'Воспроизводить звук при уведомлении',
  'settings.notifications.volume': 'Громкость уведомлений',
  'settings.notifications.volumeDesc': 'Настроить громкость',
  'settings.notifications.marketing': 'Маркетинг',
  'settings.notifications.marketingDesc': 'События и акции платформы',
  'settings.interface.title': 'Внешний вид',
  'settings.interface.description': 'Настройка интерфейса',
  'settings.interface.theme': 'Тема',
  'settings.interface.themeDesc': 'Выберите тему',
  'settings.interface.language': 'Язык',
  'settings.interface.languageDesc': 'Язык интерфейса',
  'settings.interface.animation': 'Анимации',
  'settings.interface.animationDesc': 'Включить анимации переходов',
  'settings.interface.tips': 'Подсказки',
  'settings.interface.tipsDesc': 'Показывать подсказки и руководства',
  'settings.theme.light': 'Светлая',
  'settings.theme.dark': 'Тёмная',
  'settings.theme.auto': 'Авто',
  'settings.ai.title': 'Настройки генерации ИИ',
  'settings.ai.description': 'Оптимизация качества и производительности',
  'settings.ai.autoOptimize': 'Автооптимизация',
  'settings.ai.autoOptimizeDesc': 'ИИ автоматически оптимизирует параметры',
  'settings.ai.quality': 'Качество генерации',
  'settings.ai.qualityDesc': 'Баланс скорости и качества',
  'settings.ai.cloudSync': 'Облачная синхронизация',
  'settings.ai.cloudSyncDesc': 'Синхронизировать работы в облако',
  'settings.ai.autoSave': 'Автосохранение',
  'settings.ai.autoSaveDesc': 'Сохранять результаты после генерации',
  'settings.ai.safetyFilter': 'Фильтр контента',
  'settings.ai.safetyFilterDesc': 'Фильтровать неуместный контент',
  'settings.ai.watermark': 'Водяной знак',
  'settings.ai.watermarkDesc': 'Добавлять водяной знак к работам',
  'settings.ai.promptSuggestions': 'Подсказки запросов',
  'settings.ai.promptSuggestionsDesc': 'Рекомендации по оптимизации запросов',
  'settings.quality.fast': 'Быстро',
  'settings.quality.balanced': 'Сбалансировано',
  'settings.quality.high': 'Высокое качество',
  'settings.privacy.title': 'Конфиденциальность и безопасность',
  'settings.privacy.description': 'Защита персональных данных',
  'settings.privacy.profile': 'Видимость профиля',
  'settings.privacy.profileDesc': 'Другие могут просматривать ваш профиль',
  'settings.privacy.activity': 'Статус активности',
  'settings.privacy.activityDesc': 'Друзья видят, что вы в сети',
  'settings.privacy.analytics': 'Сбор аналитики',
  'settings.privacy.analyticsDesc': 'Помочь улучшить продукт',
  'settings.privacy.showWorks': 'Видимость работ',
  'settings.privacy.showWorksDesc': 'Другие могут просматривать ваши работы',
  'settings.privacy.allowComments': 'Разрешить комментарии',
  'settings.privacy.allowCommentsDesc': 'Другие могут комментировать',
  'settings.privacy.allowDownload': 'Разрешить скачивание',
  'settings.privacy.allowDownloadDesc': 'Другие могут скачивать',
  'settings.performance.title': 'Производительность',
  'settings.performance.description': 'Настройка производительности системы',
  'settings.performance.hardware': 'Аппаратное ускорение',
  'settings.performance.hardwareDesc': 'Использовать GPU',
  'settings.performance.preview': 'Качество предпросмотра',
  'settings.performance.previewDesc': 'Уровень качества предпросмотра',
  'settings.performance.autoClean': 'Очистка кэша',
  'settings.performance.autoCleanDesc': 'Регулярно удалять временные файлы',
  'settings.performance.imageCompression': 'Сжатие изображений',
  'settings.performance.imageCompressionDesc': 'Сжимать загружаемые изображения',
  'settings.performance.lazyLoading': 'Отложенная загрузка',
  'settings.performance.lazyLoadingDesc': 'Откладывать загрузку контента',
  'settings.preview.low': 'Низкое',
  'settings.preview.medium': 'Среднее',
  'settings.preview.high': 'Высокое',
  'settings.workflow.title': 'Рабочий процесс',
  'settings.workflow.description': 'Настройка процесса генерации ИИ',
  'settings.workflow.resolution': 'Разрешение по умолчанию',
  'settings.workflow.resolutionDesc': 'Размер по умолчанию для изображений',
  'settings.workflow.saveHistory': 'Сохранять историю',
  'settings.workflow.saveHistoryDesc': 'Сохранять параметры и запросы',
  'settings.workflow.autoTag': 'Умные теги',
  'settings.workflow.autoTagDesc': 'Добавлять теги автоматически',
  'settings.workflow.template': 'Шаблоны',
  'settings.workflow.templateDesc': 'Включить шаблоны процесса',
  'settings.file.title': 'Управление файлами',
  'settings.file.description': 'Хранение и резервное копирование',
  'settings.file.autoBackup': 'Авторезервное копирование',
  'settings.file.autoBackupDesc': 'Автоматически сохранять важные файлы',
  'settings.file.backupFrequency': 'Частота резервного копирования',
  'settings.file.backupFrequencyDesc': 'Выбрать частоту',
  'settings.file.realtime': 'В реальном времени',
  'settings.file.daily': 'Ежедневно',
  'settings.file.weekly': 'Еженедельно',
  'settings.file.autoOrganize': 'Автоорганизация',
  'settings.file.autoOrganizeDesc': 'Автоматически сортировать файлы',
  'settings.file.defaultFormat': 'Формат по умолчанию',
  'settings.file.defaultFormatDesc': 'Формат сохранения по умолчанию',
  'settings.social.title': 'Социальные функции',
  'settings.social.description': 'Социальные функции и разрешения',
  'settings.social.allowFollow': 'Разрешить подписку',
  'settings.social.allowFollowDesc': 'Другие могут подписаться',
  'settings.social.allowMessage': 'Разрешить сообщения',
  'settings.social.allowMessageDesc': 'Другие могут писать вам',
  'settings.social.likeNotify': 'Уведомления о лайках',
  'settings.social.likeNotifyDesc': 'Уведомлять о лайках',
  'settings.social.mentionNotify': 'Уведомления об упоминаниях',
  'settings.social.mentionNotifyDesc': 'Уведомлять при упоминании',
  'settings.security.title': 'Безопасность аккаунта',
  'settings.security.description': 'Усиление защиты',
  'settings.security.twoFactor': 'Двухфакторная аутентификация',
  'settings.security.twoFactorDesc': 'Дополнительный уровень защиты',
  'settings.security.loginNotify': 'Уведомления о входе',
  'settings.security.loginNotifyDesc': 'Уведомлять о входе с нового устройства',
  'settings.security.deviceVerify': 'Проверка устройства',
  'settings.security.deviceVerifyDesc': 'Неавторизованные устройства требуют проверки',
  'settings.security.autoLogout': 'Автовыход',
  'settings.security.autoLogoutDesc': 'Выход после длительного бездействия',
  'settings.button.save': 'Сохранить',
  'settings.button.reset': 'Сбросить',
  'settings.badge.on': 'Вкл',
  'settings.badge.recommended': 'Рекомендуется',
  'settings.message.saveSuccess': 'Настройки сохранены',
  'settings.message.autoSaved': 'Настройки сохранены автоматически',
  'settings.message.saveFailed': 'Ошибка сохранения',
  'settings.message.resetSuccess': 'Настройки сброшены',
  'settings.autoSaveHint': 'Настройки сохраняются автоматически',
  'settings.confirm.resetTitle': 'Подтвердите сброс',
  'settings.confirm.resetContent': 'Сбросить все настройки по умолчанию?',
  'settings.confirm.reset': 'Сбросить',
  'settings.confirm.cancel': 'Отмена',

  // Prompt Version History
  'prompt.version.label.prompt': 'Промпт',
  'prompt.version.label.negativePrompt': 'Негативный промпт',
  'prompt.version.label.result': 'Результат',
}; 